import React, { useState, useEffect, useRef , useMemo ,useCallback } from 'react';
//import { Clock, CheckCircle, XCircle, AlertCircle, Globe, IndianRupee, DollarSign, LogOut, User, Trophy, TrendingUp, BookOpen, Target, RefreshCw, Eye, EyeOff, Gift } from 'lucide-react';
//import { Clock, CheckCircle, XCircle, AlertCircle, Globe, IndianRupee, DollarSign, LogOut, User, Trophy, TrendingUp, BookOpen, Target, RefreshCw, Eye, EyeOff, Gift, Shield } from 'lucide-react';
import { Clock, CheckCircle, XCircle, AlertCircle, Globe, IndianRupee, DollarSign, LogOut, User, Trophy, TrendingUp, BookOpen, Target, RefreshCw, Eye, EyeOff, Gift, Shield, Menu, X } from 'lucide-react';
import PasswordStrengthIndicator from './PasswordStrengthIndicator';
import ChapterExamSelector from './ChapterExamSelector';
import ExamInterface from './ExamInterface';
import { Buffer } from 'buffer';
import ExamReview from './ExamReview';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import HeroSection from './HeroSection';
import CertificateGenerator from './CertificateGenerator';
import useSEO from './hooks/useSEO';
import NavigationMenu from './components/NavigationMenu';

// ⬇️ add this new state



// const CURRENCIES = {
//      IN: { code: 'INR', examPrice: 1400, display: '₹1,400' },
//      US: { code: 'USD', examPrice: 16, display: '$16' }
//    };

const CURRENCIES = {
  IN: { code: 'INR', examPrice: 1400, display: '₹1,400' },
  US: { code: 'USD', examPrice: 16, display: '$16' }
};

const EXAM_TYPE_LABELS = {
  certification: "Full Certification",
  full: "Random Practice",
  mixed: "Mixed Practice",
  random: "Random Practice",
  chapter: "Chapter Focus",
 // focused: "Focused Exam",  // ✅ ADD THIS
};
function App() {
  const [lastAttempt, setLastAttempt] = useState(null);
  const [userCountry, setUserCountry] = useState('DEFAULT');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false); 

  const [currentPage, setCurrentPage] = useState('landing'); // landing, register, login, dashboard, exam
  const [user, setUser] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [examHistory, setExamHistory] = useState([]);
  const [trialError, setTrialError] = useState(null);
  const [paymentError, setPaymentError] = useState(null);
  
  // New exam configuration state
  const [examConfig, setExamConfig] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState(65 * 60);
  const [examSubmitted, setExamSubmitted] = useState(false);
  const [score, setScore] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Form states
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
const [mobilePracticeOpen, setMobilePracticeOpen] = useState(false);
const [mobileGuidesOpen, setMobileGuidesOpen] = useState(false);
const [mobileBlogOpen, setMobileBlogOpen] = useState(false);
  
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://a9csjxv6ha.execute-api.us-east-1.amazonaws.com/prod';
  const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_RKwgMpiTTRCvF7';
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('token') && params.get('email')) {
      setShowResetPassword(true);
      setCurrentPage('reset-password');
    }
  }, []);





 useEffect(() => {
  // Clear stale auth data if user arrives from email verification
  const urlParams = new URLSearchParams(window.location.search);
  const fromVerification = urlParams.get('verified');
  
  if (fromVerification === 'true') {
    console.log('🔄 User arrived from email verification - clearing old auth data');
    
    // Clear any old auth data to force fresh login
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    sessionStorage.clear();  // ✅ ADD THIS LINE
    setAuthToken(null);
    setUser(null);
    setCurrentPage('login');
    
    // Clean URL by removing the ?verified=true parameter
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}, []);





const handleLogout = useCallback(() => {
  // Clear all storage items
  localStorage.removeItem('authToken');
  localStorage.removeItem('userData');
  sessionStorage.clear();
  
  // ✅ Extra safety: Remove any items that got set to "undefined" string
  if (localStorage.getItem('authToken') === 'undefined') {
    localStorage.removeItem('authToken');
  }
  if (localStorage.getItem('userData') === 'undefined') {
    localStorage.removeItem('userData');
  }
  
  // Clear all state
  setAuthToken(null);
  setUser(null);
  setQuestions([]);
  setExamConfig(null);
  setTimeRemaining(65 * 60);
  setExamSubmitted(false);
  setScore(0);
  setError(null);
  setTrialError(null);
  setPaymentError(null);
  
  setCurrentPage('landing');
  
  console.log('✅ Logged out and cleared all data');
}, []);

const makeAuthenticatedRequest = useCallback(
  async (url, options = {}) => {
    const headers = {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    };

    const token = localStorage.getItem('authToken');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(url, {
      ...options,
      headers
    });

    // 🔒 Session / auth invalid
    if (response.status === 401) {
      alert(
        'For security reasons, only one browser session is allowed at a time. Your session has expired or you logged in from another device or browser. Please log in again'
      );
      handleLogout();
      throw new Error('SESSION_INVALID');
    }

    return response;
  },
  [handleLogout] // ✅ THIS fixes the ESLint warning
);

const validateAuthToken = useCallback(async () => {
  try {
    const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/validate-token`);
    return response.ok;
  } catch (e) {
    return false;
  }
}, [makeAuthenticatedRequest]);

//   const checkAuthStatus = useCallback(async () => {
//   const token = localStorage.getItem('authToken');
//   const userData = localStorage.getItem('userData');

//   // ✅ ADD THIS CHECK
//   if (!token || !userData || token === 'undefined' || userData === 'undefined') {
//     console.log('🔒 No valid auth data found');
//     return;
//   }
//   if (token && userData) {
//     try {
//       const user = JSON.parse(userData);
//       const tokenData = JSON.parse(Buffer.from(token, 'base64').toString());

//       //if (tokenData.exp < Date.now()) {
//       if (tokenData.exp * 1000 < Date.now()) {

//         console.log('🔒 Token expired, logging out');
//         handleLogout();
//         return;
//       }

//       try {
//         const subResponse = await fetch(
//           `${API_ENDPOINT}/subscription-status?email=${user.email}`,
//           {
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           }
//         );

//         if (subResponse.ok) {
//           const subData = await subResponse.json();
          
//           const updatedUser = {
//             ...user,
//             hasActiveSubscription: subData.hasActiveSubscription || false,
//             subscriptionType: subData.subscriptionType || null,
//             questionsRemaining: subData.questionsRemaining || 0
//           };

//           localStorage.setItem('userData', JSON.stringify(updatedUser));
//           setUser(updatedUser);
//           setAuthToken(token);
//           setCurrentPage(updatedUser.hasActiveSubscription ? 'dashboard' : 'payment');
//         } else {
//           console.warn('⚠️ Subscription validation failed');
//           handleLogout();
//         }
//       } catch (error) {
//         console.error('❌ Failed to validate subscription:', error);
//         handleLogout();
//       }
//     } catch (error) {
//       console.error('Invalid auth data:', error);
//       handleLogout();
//     }
//   }
// }, [handleLogout, API_ENDPOINT]);

const checkAuthStatus = useCallback(async () => {
  const urlParams = new URLSearchParams(window.location.search);

  // 🔓 PUBLIC FLOWS — NEVER CHECK AUTH
  if (
    (urlParams.get('token') && urlParams.get('email')) ||   // password reset
    urlParams.get('verified') === 'true'                    // email verification
  ) {
    console.log('🔓 Public flow detected — skipping auth check');
    return;
  }

  const token = localStorage.getItem('authToken');
  const userData = localStorage.getItem('userData');

  // 🚫 No auth data
  if (!token || !userData || token === 'undefined' || userData === 'undefined') {
    console.log('🔒 No valid auth data found');
    return;
  }

  try {
    const user = JSON.parse(userData);
    const tokenData = JSON.parse(
      Buffer.from(token, 'base64').toString()
    );

    // ⏳ Token expired
    if (tokenData.exp * 1000 < Date.now()) {
      console.log('🔒 Token expired, logging out');
      handleLogout();
      return;
    }

    // 🔍 Validate subscription
    const subResponse = await fetch(
      `${API_ENDPOINT}/subscription-status?email=${user.email}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!subResponse.ok) {
      console.warn('⚠️ Subscription validation failed');
      handleLogout();
      return;
    }

    const subData = await subResponse.json();

    const updatedUser = {
      ...user,
      hasActiveSubscription: subData.hasActiveSubscription || false,
      subscriptionType: subData.subscriptionType || null,
      questionsRemaining: subData.questionsRemaining || 0
    };

    localStorage.setItem('userData', JSON.stringify(updatedUser));
    setUser(updatedUser);
    setAuthToken(token);
    setCurrentPage(
      updatedUser.hasActiveSubscription ? 'dashboard' : 'payment'
    );

  } catch (error) {
    console.error('❌ Invalid auth data:', error);
    handleLogout();
  }
}, [handleLogout, API_ENDPOINT]);


  
// useEffect(() => {
//   // Skip auth check if coming from email verification
//   const urlParams = new URLSearchParams(window.location.search);
//   if (urlParams.get('verified') === 'true') {
//     console.log('⏭️ Skipping auth check - verification useEffect will handle it');
//     return;
//   }
  
//   checkAuthStatus();
// }, [checkAuthStatus]);

useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);

  // ✅ Skip auth check if coming from email verification
  if (urlParams.get('verified') === 'true') {
    console.log('⏭️ Skipping auth check - verification flow');
    return;
  }

  // ✅ Skip auth check if coming from password reset link
  if (urlParams.get('token') && urlParams.get('email')) {
    console.log('🔐 Skipping auth check - password reset flow');
    return;
  }

  checkAuthStatus();
}, [checkAuthStatus]);





// useEffect(() => {
//   const urlParams = new URLSearchParams(window.location.search);
//   const token = urlParams.get('token'); // PayPal order ID
//   const payerId = urlParams.get('PayerID');
  
//   if (!token || !payerId) {
//     return; // No PayPal parameters, exit early
//   }
  
//   // ✅ CRITICAL FIX: Prevent duplicate processing
//   const processingKey = `paypal_processed_${token}`;
  
//   // Check if this order was already processed
//   if (sessionStorage.getItem(processingKey)) {
//     console.log('⏭️ Order already processed, skipping duplicate verification');
//     return;
//   }
  
//   // Mark this order as being processed
//   sessionStorage.setItem(processingKey, 'true');
//   console.log('🔄 Processing PayPal order:', token);
  
//   // Only process if not already on processing page
//   if (currentPage === 'paypal-processing') {
//     return;
//   }
  
//   // ✅ Define verification logic inline
//   const verifyPayPalPayment = async () => {
//     setCurrentPage('paypal-processing');
//     setIsLoading(true);
    
//     try {
//       // Get user from localStorage if not in state yet
//       const currentUser = user || JSON.parse(localStorage.getItem('userData') || 'null');
//       const currentToken = authToken || localStorage.getItem('authToken');
      
//       if (!currentUser || !currentUser.email) {
//         throw new Error('User session not found. Please login again.');
//       }
      
//       console.log('🔍 Verifying PayPal payment for:', currentUser.email);
      
// const response = await fetch(`${API_ENDPOINT}/verify-paypal-payment`, {
//   method: 'POST',
//   headers: {
//     'Authorization': `Bearer ${currentToken}`,
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify({
//     orderId: token,  // ✅ CORRECT
//     userEmail: currentUser.email,
//     environment: process.env.NODE_ENV === 'production' ? 'live' : 'sandbox'
//   })
// });

//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//       }

//       const data = await response.json();
      
//     if (data.verified) {
//   // ✅ Update storage
//   localStorage.setItem('authToken', data.token);
//   localStorage.setItem('userData', JSON.stringify(data.user));
  
//   // ✅ Clean URL before reload
//   window.history.replaceState({}, document.title, window.location.pathname);
  
//   // ✅ Force full page reload to pick up new token
//   alert('Payment successful! Your subscription is now active. Redirecting to dashboard...');
//   window.location.href = '/';  // Full reload
// } else {
//         throw new Error('Payment verification failed');
//       }
//     } catch (error) {
//       console.error('❌ PayPal verification failed:', error);
//       setError(`Payment verification failed: ${error.message}`);
//       setCurrentPage('payment');
//     } finally {
//       setIsLoading(false);
//     }
//   };
  
//   // Execute verification
//   verifyPayPalPayment();
  
// }, [currentPage, user, authToken, API_ENDPOINT, setCurrentPage, setIsLoading, setUser, setAuthToken, setError]);
  const paypalHandledRef = useRef(false);

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const orderId = params.get('token');
  const payerId = params.get('PayerID');

  if (!orderId || !payerId) return;

  // 🔒 HARD STOP — runs only once per page load
  if (paypalHandledRef.current) {
    console.log('⏭️ PayPal already handled');
    return;
  }
  paypalHandledRef.current = true;

  const verify = async () => {
    try {
      setIsLoading(true);
      setCurrentPage('paypal-processing');

      const currentUser =
        user || JSON.parse(localStorage.getItem('userData') || 'null');
      const token =
        authToken || localStorage.getItem('authToken');

      if (!currentUser?.email || !token) {
        throw new Error('Session expired. Please login again.');
      }

      console.log('🔍 Verifying PayPal order:', orderId);

      const res = await fetch(`${API_ENDPOINT}/verify-paypal-payment`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderId,
          userEmail: currentUser.email,
          environment:
            process.env.NODE_ENV === 'production' ? 'live' : 'sandbox'
        })
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      if (!data.verified) throw new Error('Verification failed');

      // ✅ Persist auth
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('userData', JSON.stringify(data.user));

      // ✅ REMOVE PayPal params IMMEDIATELY
      window.history.replaceState({}, document.title, '/');

      alert('Payment successful!');
      window.location.reload();

    } catch (err) {
      console.error('❌ PayPal verification failed:', err);
      paypalHandledRef.current = false; // allow retry
      setError(err.message);
      setCurrentPage('payment');
    } finally {
      setIsLoading(false);
    }
  };

  verify();

  // 🚫 EMPTY dependency array (intentional)
}, []);


  const handleForgotPasswordClick = () => {
    setShowForgotPassword(true);
    setCurrentPage('forgot-password');
  };

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    setShowResetPassword(false);
    setCurrentPage('login');
    window.history.replaceState({}, document.title, window.location.pathname);
  };

  



  const handleResetPasswordSuccess = () => {
    setShowResetPassword(false);
    setCurrentPage('login');
    window.history.replaceState({}, document.title, window.location.pathname);
    alert('Password reset successful! Please login with your new password.');
  };




//   const fetchExamHistory = async () => {
//   try {
//     const response = await makeAuthenticatedRequest(
//       `${API_ENDPOINT}/java-cert-get-exam-history?email=${user.email}`
//     );
    
//     if (response.ok) {
//       const data = await response.json();
//       setExamHistory(data.examHistory || []);
//     }
//   } catch (error) {
//     console.error('Failed to fetch exam history:', error);
//   }
// };

const fetchExamHistory = useCallback(async () => {
  if (!authToken) return;

  try {
    const response = await makeAuthenticatedRequest(
      `${API_ENDPOINT}/java-cert-get-exam-history`
    );

    if (response.ok) {
      const data = await response.json();
      setExamHistory(data.examHistory || []);
    }
  } catch (error) {
  if (error.message === 'SESSION_INVALID') return;
  console.error('Failed to fetch exam history:', error);
}
}, [authToken, API_ENDPOINT, makeAuthenticatedRequest]);


useEffect(() => {
  if (currentPage === 'dashboard') {
    fetchExamHistory();
  }
}, [currentPage, fetchExamHistory]);
  



const handleRegister = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setError(null);

  try {
    const response = await fetch(`${API_ENDPOINT}/register`, {

      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (response.status === 503 && data.disabled) {
      setError('Registration is temporarily disabled. Please check back later.');
    } else if (response.ok) {
  // ✅ Show success message and redirect to login
  setError(null);
  setFormData({ email: formData.email, password: '', name: '' });
  setCurrentPage('login');
  
  // ✅ Use setTimeout to ensure alert shows after page change
  setTimeout(() => {
    alert('Registration successful! Please check your email for a verification link.');
  }, 100);
} else {
      setError(data.error || 'Registration failed');
    }
  } catch (error) {
    console.error('Registration error:', error);
    setError('Registration failed. Please try again.');
  } finally {
    setIsLoading(false);
  }
};



 const handleLogin = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setError(null);

  try {
    const response = await fetch(`${API_ENDPOINT}/login`, {

      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: formData.email,
        password: formData.password
      })
    });

    const data = await response.json();

    if (response.ok) {
      localStorage.setItem('authToken', data.token);
      setAuthToken(data.token);

      try {
        const subResponse = await fetch(
          `${API_ENDPOINT}/subscription-status?email=${data.user.email}`,
          {
            headers: {
              'Authorization': `Bearer ${data.token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (subResponse.ok) {
          const subData = await subResponse.json();
          
          const verifiedUser = {
            ...data.user,
            hasActiveSubscription: subData.hasActiveSubscription || false,
            subscriptionType: subData.subscriptionType || null,
            questionsRemaining: subData.questionsRemaining || 0,
            trialUsed: subData.trialUsed || false
          };

          localStorage.setItem('userData', JSON.stringify(verifiedUser));
          setUser(verifiedUser);
          setError(null);
          setFormData({ email: '', password: '', name: '' });
          setCurrentPage(verifiedUser.hasActiveSubscription ? 'dashboard' : 'payment');
        } else {
          console.warn('⚠️ Could not verify subscription, showing payment page');
          localStorage.setItem('userData', JSON.stringify(data.user));
          setUser(data.user);
          setCurrentPage('payment');
        }
      } catch (subError) {
        console.error('❌ Subscription check failed:', subError);
        localStorage.setItem('userData', JSON.stringify(data.user));
        setUser(data.user);
        setCurrentPage('payment');
      }
    } else {
      setError(data.error || 'Login failed');
    }
  } catch (error) {
    console.error('Login error:', error);
    setError('Login failed. Please try again.');
  } finally {
    setIsLoading(false);
  }
};





const handlePayPalReturn = async (orderId) => {
  setCurrentPage('paypal-processing');
  setIsLoading(true);
  
  try {
    // ✅ Get user from localStorage if not in state yet
    const currentUser = user || JSON.parse(localStorage.getItem('userData') || 'null');
    const currentToken = authToken || localStorage.getItem('authToken');
    
    if (!currentUser || !currentUser.email) {
      throw new Error('User session not found. Please login again.');
    }
    
    console.log('🔍 Verifying PayPal payment for:', currentUser.email);
    
const response = await fetch(`${API_ENDPOINT}/go-verify-paypal-payment-lambda`, {
  method: 'POST',
  headers: {
    'Authorization': `Bearer ${currentToken}`,
    'Content-Type': 'application/json'
  },
body: JSON.stringify({
    orderId: orderId,  // ✅ CORRECT: Use the function parameter
    userEmail: currentUser.email,
    environment: process.env.NODE_ENV === 'production' ? 'live' : 'sandbox'
})
});

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    
    if (data.verified) {
      const updatedUser = { ...currentUser, ...data.user };
      localStorage.setItem('userData', JSON.stringify(updatedUser));
      localStorage.setItem('authToken', data.token);
      setUser(updatedUser);
      setAuthToken(data.token);
      
      window.history.replaceState({}, document.title, window.location.pathname);
      
      setCurrentPage('dashboard');
      alert('Payment successful! Your subscription is now active.');
    } else {
      throw new Error('Payment verification failed');
    }
  } catch (error) {
    console.error('❌ PayPal verification failed:', error);
    setError(`Payment verification failed: ${error.message}`);
    setCurrentPage('payment');
  } finally {
    setIsLoading(false);
  }
};
  const handleActivateFreeTrial = async () => {
  if (!authToken) {
    //setError('Please login first');
    setTrialError('Please login first');
    return;
  }

  setIsLoading(true);
  //setError(null);
  setTrialError(null); 
  
  try {
    const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/activate-free-trial`, {
      method: 'POST',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || data.error || 'Failed to activate free trial');
    }

    if (data.success) {
      // Update user state with trial subscription
      const updatedUser = { 
        ...user, 
        hasActiveSubscription: true, 
        subscriptionType: 'trial' 
      };
      
      localStorage.setItem('userData', JSON.stringify(updatedUser));
      setUser(updatedUser);
      
      alert('🎉 ' + data.message);
      setCurrentPage('dashboard');
    }
  } catch (error) {
  if (error.message === 'SESSION_INVALID') return;
  console.error('Free trial activation failed:', error);
  setTrialError(error.message);
}
 finally {
    setIsLoading(false);
  }
};

  
const initiateRazorpayCheckout = (orderData) => {
  if (!window.Razorpay) {
    setError('Razorpay script not loaded. Please refresh the page.');
    setIsLoading(false);
    return;
  }

  const options = {
    key: RAZORPAY_KEY_ID,
    amount: orderData.amount,
    currency: orderData.currency,
    name: 'Java Certification Practice Pro',
    description: 'Full Access Subscription - 6 months',  // ✅ FIXED - Static text
    order_id: orderData.orderId,
    prefill: {
      name: orderData.userName,
      email: orderData.userEmail,
    },
    theme: { color: '#4F46E5' },
    handler: async function (response) {
      await verifyPayment(response);
    },
    modal: {
      ondismiss: function() {
        setIsLoading(false);
      }
    }
  };
  
  try {
    const rzp = new window.Razorpay(options);
    rzp.open();
  } catch (error) {
    console.error('Failed to open Razorpay:', error);
    setError('Failed to open payment gateway');
    setIsLoading(false);
  }
};

  const verifyPayment = async (paymentResponse) => {
    try {
      setIsLoading(true);
 const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/verify-payment`, {
  method: 'POST',
  body: JSON.stringify({
    razorpay_payment_id: paymentResponse.razorpay_payment_id,
    razorpay_order_id: paymentResponse.razorpay_order_id,
    razorpay_signature: paymentResponse.razorpay_signature,
    userEmail: user.email,
    environment: process.env.NODE_ENV === 'production' ? 'live' : 'test' // ✅ NEW
  })
});

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
  if (data.verified) {
  // ✅ Update storage
  localStorage.setItem('authToken', data.token);
  localStorage.setItem('userData', JSON.stringify(data.user));
  
  // ✅ Force full page reload to pick up new token
  alert('Payment successful! Your subscription is now active. Redirecting to dashboard...');
  window.location.href = '/';  // Full reload
} else {
  throw new Error('Payment verification failed');
}
    } catch (error) {
  if (error.message === 'SESSION_INVALID') return;
  console.error('Payment verification failed:', error);
  setError(`Payment verification failed: ${error.message}`);
}
 finally {
      setIsLoading(false);
    }
  };

  // Updated function to handle exam start with configuration
  const handleStartExam = async (config) => {
    setExamConfig(config);
    await loadQuestions(config);
  };

  // Updated loadQuestions function to accept exam configuration
 const loadQuestions = async (config) => {
  try {
    setIsLoading(true);
    setError(null);

    // 🔐 STEP 1: Validate subscription (protected endpoint)
    const subResponse = await makeAuthenticatedRequest(
      `${API_ENDPOINT}/subscription-status?email=${user.email}`
    );

    // ⛔ Session invalidation already handled inside makeAuthenticatedRequest
    if (!subResponse) return;

    if (!subResponse.ok) {
      const errData = await subResponse.json().catch(() => ({}));
      throw new Error(errData.message || 'Please verify your subscription status');
    }

    const subData = await subResponse.json();

    if (!subData.hasActiveSubscription) {
      setError('Your subscription has expired. Please renew to continue.');
      setCurrentPage('payment');
      return;
    }

    if (
      subData.subscriptionType === 'trial' &&
      subData.questionsRemaining <= 0
    ) {
      setError(
        'You have used all your free trial questions. Please subscribe for unlimited access.'
      );
      setCurrentPage('payment');
      return;
    }

    // 📌 STEP 2: Determine questions endpoint
    let endpoint;
    let queryParams;

    // if (config.type === 'focused') {
    //   endpoint = `${API_ENDPOINT}/java-cert-get-focus-questions`;
    //   queryParams = `chapter=${encodeURIComponent(config.chapter)}`;
    //   console.log('🎯 Using focused questions endpoint:', endpoint);
    // } else {
      endpoint = `${API_ENDPOINT}/questions`;
      const params = new URLSearchParams({
        examType: config.type,
        ...(config.chapter && { chapter: config.chapter }),
        ...(config.difficulty && { difficulty: config.difficulty }),
        ...(config.testNumber && { testNumber: config.testNumber })
      });
      queryParams = params.toString();
      console.log('📋 Using standard questions endpoint:', endpoint);
    //}

    console.log('🚀 Loading questions with config:', config);

    // 📘 STEP 3: Fetch questions (protected endpoint)
    const response = await makeAuthenticatedRequest(
      `${endpoint}?${queryParams}`
    );

    // ⛔ Session invalidation already handled
    if (!response) return;

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();

    if (!data.questions || data.questions.length === 0) {
      throw new Error('No questions received from server');
    }

    // 🧠 STEP 4: Initialize exam state
    setQuestions(data.questions);
    setCurrentPage('exam');

    const actualQuestionCount = data.questions.length;
    let calculatedTimeLimit;

    // if (config.type === 'focused') {
    //   calculatedTimeLimit = config.isPracticeMode
    //     ? Math.ceil(actualQuestionCount * 3)
    //     : Math.ceil(actualQuestionCount * 2);

    //   console.log(
    //     `⏱️ Focused exam: ${actualQuestionCount} questions = ${calculatedTimeLimit} minutes`
    //   );
    // } else {
      calculatedTimeLimit = config.timeLimit || 120;
    //}

    setTimeRemaining(calculatedTimeLimit * 60);
    setExamSubmitted(false);
    setScore(0);
  } catch (error) {
    // 🔒 Session invalid already handled globally
    if (error.message === 'SESSION_INVALID') return;

    console.error('❌ Failed to load questions:', error);
    setError(error.message || 'Failed to load questions');
  } finally {
    setIsLoading(false);
  }
};

 



const handleSubmitExam = async (examAnswers) => { 
  setIsLoading(true);
  setError(null);

  try {
    // Build answers payload
    const payloadAnswers = {};
    questions.forEach((q, idx) => {
      const sel = examAnswers[idx];
      if (sel !== undefined && q?.questionId && Array.isArray(q.options)) {
        if (Array.isArray(sel)) {
          payloadAnswers[q.questionId] = sel.map(i => q.options[i]);
        } else {
          payloadAnswers[q.questionId] = [q.options[sel]];
        }
      }
    });

    console.log("📤 Submitting exam with:", {
      totalQuestions: questions.length,
      answered: Object.keys(payloadAnswers).length,
      examType: examConfig?.type,
      chapter: examConfig?.chapter,
      testNumber: examConfig?.testNumber,
      timeSpent: ((examConfig?.timeLimit || 120) * 60) - timeRemaining
    });

    const calculatedScore = calculateScore(examAnswers);
    //const questionIds = questions.map(q => String(q.questionId));
    const questionIds = questions.map(q => Number(q.questionId));


    console.log("🧩 QuestionIds being sent:", questionIds.slice(0, 10));

    // ✅ Build payload with smart testNumber handling
    // const payload = {
    //   examId: 'java-cert-basic',
    //   examType: examConfig?.type || 'full',
    //   answers: payloadAnswers,
    //   questionIds,
    //   timeSpent: ((examConfig?.timeLimit || 120) * 60) - timeRemaining
    // };

    // // ✨ Set chapter and testNumber based on exam type
    // if (examConfig?.type === 'certification') {
    //   // Certification: has testNumber, no chapter
    //   payload.testNumber = examConfig.testNumber || 1;
    //   payload.chapter = 'N/A';
    //   console.log('📋 Certification test #' + payload.testNumber);
    // } else if (examConfig?.type === 'focused') {
    //   // Focused: has chapter (set name), no testNumber
    //   payload.testNumber = null;
    //   payload.chapter = examConfig.chapter || 'N/A';
    //   console.log('🎯 Focused exam:', payload.chapter);
    // } else {
    //   // Full/Mixed: no testNumber, no chapter
    //   payload.testNumber = null;
    //   payload.chapter = 'N/A';
    //   console.log('🎲 ' + examConfig?.type + ' exam');
    // }
//const questionIds = questions.map(q => Number(q.questionId));

let testNumber = 0;
let chapter = 'N/A';

// if (examConfig?.type === 'certification') {
//   testNumber = Number(examConfig.testNumber || 1);
// } else if (examConfig?.type === 'focused') {
//   chapter = examConfig.chapter || 'N/A';
// }

const payload = {
  examId: 'java-cert-basic',
  examType: examConfig?.type || 'full',
  answers: payloadAnswers,
  questionIds,
  testNumber,
  chapter,
  timeSpent: ((examConfig?.timeLimit || 120) * 60) - timeRemaining
};

    console.log("📤 Final payload:", JSON.stringify(payload, null, 2));

    const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/submit-exam`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    let finalScore = calculatedScore;
    let resultData = null;

    if (response.ok) {
      const data = await response.json();
      console.log("📥 Lambda response:", data);
      finalScore = data?.result?.score ?? calculatedScore;
      resultData = data?.result;
    } else {
      console.warn("⚠️ Lambda returned non-200:", response.status);
    }

    // ✅ Deep copy of full question objects to preserve text, code, and explanation
    const clonedQuestions = questions.map(q => ({
      questionId: q.questionId,
      question: q.question,
      code: q.code,
      options: q.options,
      correctAnswer: q.correctAnswer,
      correctAnswers: q.correctAnswers,
      explanation: q.explanation,
      chapter: q.chapter,
      difficulty: q.difficulty,
    }));

    setLastAttempt({
      questions: clonedQuestions,
      answers: payloadAnswers,
      score: finalScore,
      percentage: resultData?.percentage ?? ((finalScore / questions.length) * 100).toFixed(2),
      examType: examConfig?.type || 'full',
      chapter: examConfig?.chapter,
      testNumber: examConfig?.testNumber || null,
      submittedAt: new Date().toISOString()
    });

    setScore(finalScore);
    setExamSubmitted(true);
    setCurrentPage('results');

  } catch (error) {
    if (error.message === 'SESSION_INVALID') return;
    console.error("❌ Failed to submit exam:", error);
    const fallbackScore = calculateScore(examAnswers);

    setLastAttempt({
      questions,
      answers: examAnswers,
      score: fallbackScore,
      percentage: ((fallbackScore / questions.length) * 100).toFixed(2),
      //examType: examConfig?.type || 'full',
      examType:examConfig?.type === 'focused' ? 'chapter' : examConfig?.type || 'full',
      chapter: examConfig?.chapter,
      testNumber: examConfig?.testNumber || null,
      submittedAt: new Date().toISOString()
    });

    setScore(fallbackScore);
    setExamSubmitted(true);
    setCurrentPage('results');
  } finally {
    setIsLoading(false);
  }
};

  // const calculateScore = (examAnswers) => {
  //   let correctAnswers = 0;
  //   questions.forEach((question, index) => {
  //     if (examAnswers[index] === question.correctAnswer) {
  //       correctAnswers++;
  //     }
  //   });
  //   return correctAnswers;
  // };
const calculateScore = (examAnswers) => {
  let correct = 0;

  questions.forEach((q, i) => {
    const userAnswer = examAnswers[i];

    if (Array.isArray(q.correctAnswers)) {
      if (
        Array.isArray(userAnswer) &&
        userAnswer.length === q.correctAnswers.length &&
        userAnswer.every(a => q.correctAnswers.includes(a))
      ) {
        correct++;
      }
    } else {
      if (userAnswer === q.correctAnswer) {
        correct++;
      }
    }
  });

  return correct;
};

  const styles = {
    container: {
      minHeight: '100vh',

background: `
  radial-gradient(circle at top center, rgba(255,255,255,0.4), transparent 60%),
  linear-gradient(135deg, #e9ecf3 0%, #cfd6e2 100%)
`,


      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    card: {
      backgroundColor: '#ffffff',
      
      borderRadius: '16px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
      border: 'none',
      overflow: 'hidden'
    },
    primaryButton: {
      background: 'linear-gradient(135deg, #1da314ff 0%, #52a95dff 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '12px',
      padding: '16px 32px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      width: '100%',
      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
    },
    secondaryButton: {
      backgroundColor: 'transparent',
      color: '#44a748ff',
      border: '2px solid #42a44fff',
      borderRadius: '12px',
      padding: '12px 24px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    input: {
      width: '100%',
      padding: '12px 16px',
      border: '2px solid #e2e8f0',
      borderRadius: '12px',
      fontSize: '16px',
      marginBottom: '16px',
      transition: 'border-color 0.3s ease'
    },
    formGroup: {
      marginBottom: '20px'
    },
    label: {
      display: 'block',
      marginBottom: '8px',
      fontWeight: '600',
      color: '#374151'
    }
  };

  // ✅ CORRECT - Calculate SEO config with useMemo FIRST
  const seoConfig = useMemo(() => {
    switch (currentPage) {
      case 'landing':
        return {
          title: 'Java SE 8 OCA Certification Practice Tests',
          description: 'Master Java SE 8 OCA certification (1Z0-808) with 1,624+ practice questions, 29 full-length tests, instant feedback, and detailed explanations. Start your free 30-question trial today!',
          canonical: 'https://javalearn.clustermicro.com/',
          //keywords: 'Java OCA 8, 1Z0-808, Java certification, OCA practice test, Java SE 8 exam, Oracle certification, Java exam prep'
        };
      
      case 'login':
        return {
          title: 'Login',
          description: 'Login to your Java OCA 8 practice account',
          noindex: true,
        };
      
      case 'register':
        return {
          title: 'Create Account',
          description: 'Create your account to start practicing for Java OCA 8 certification',
          noindex: true,
        };
      
      case 'payment':
        return {
          title: 'Choose Your Plan - Java OCA 8 Practice',
          description: 'Get unlimited access to 1,624+ Java OCA 8 practice questions for 6 months. Plans starting at ₹1,400 (India) or $16 (International). Free 30-question trial available.',
          canonical: 'https://javalearn.clustermicro.com/pricing',
        };
      
      case 'dashboard':
        return {
          title: 'Dashboard',
          description: 'Your Java OCA 8 practice dashboard',
          noindex: true,
        };
      
      case 'exam':
  return {
    title: 'Practice Exam (Private)',
    description: 'Private exam session',
    noindex: true,
  };

case 'results':
  return {
    title: 'Exam Results (Private)',
    description: 'Private exam results',
    noindex: true,
  };

      
      case 'certificates':
        return {
          title: 'My Certificates',
          description: 'Your earned Java OCA 8 certificates',
          noindex: true,
        };
      
      case 'review':
        return {
          title: 'Review Mistakes',
          description: 'Review your exam mistakes',
          noindex: true,
        };
      
      case 'privacy-policy':
        return {
          title: 'Privacy Policy',
          description: 'Privacy policy for JavaLearn Java OCA 8 practice platform',
          canonical: 'https://javalearn.clustermicro.com/privacy-policy',
        };
      
      case 'terms':
  return {
    title: 'Terms and Conditions',
    description: 'Terms of service for JavaLearn',
    canonical: 'https://javalearn.clustermicro.com/terms.html',
  };

case 'refund-policy':
  return {
    title: 'Refund Policy',
    description: 'Refund policy for JavaLearn',
    canonical: 'https://javalearn.clustermicro.com/refund.html',
  };

case 'contact':
  return {
    title: 'Contact Us',
    description: 'Contact JavaLearn support',
    canonical: 'https://javalearn.clustermicro.com/contact.html',
  };

      
      case 'forgot-password':
        return {
          title: 'Forgot Password',
          description: 'Reset your password',
          noindex: true,
        };
      
      case 'reset-password':
        return {
          title: 'Reset Password',
          description: 'Create new password',
          noindex: true,
        };
      
      case 'paypal-processing':
        return {
          title: 'Processing Payment',
          description: 'Processing your payment',
          noindex: true,
        };
      
      default:
        return {
          title: currentPage,
          description: 'JavaLearn - Java OCA 8 Practice',
          noindex: true,
        };
    }
  }, [currentPage]);

  // ✅ NOW call useSEO with the config
  useSEO(seoConfig);
  // PayPal Processing Page
if (currentPage === 'paypal-processing') {
  return (
    <div style={styles.container}>
      <div style={{maxWidth: '600px', margin: '0 auto', padding: '40px 20px'}}>
        <div style={{...styles.card, padding: '60px 40px', textAlign: 'center'}}>
          <RefreshCw 
            size={64} 
            style={{
              margin: '0 auto 24px',
              animation: 'spin 1s linear infinite',
              color: '#667eea'
            }} 
          />
          <h2 style={{fontSize: '24px', fontWeight: 'bold', marginBottom: '16px'}}>
            Processing Your Payment
          </h2>
          <p style={{color: '#64748b', fontSize: '16px'}}>
            Please wait while we verify your PayPal payment...
          </p>
        </div>
      </div>
      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

// // Add this near the top of your App() function, after the styles object
// const mobileResponsiveCSS = `
//   /* ========== MOBILE RESPONSIVE - Only applies on small screens ========== */
  
//   @media (max-width: 768px) {
//     /* ChapterExamSelector - Exam Type Grid: 4 cols → 2 cols */
//     div[style*="grid-template-columns: 1fr 1fr 1fr 1fr"] {
//       grid-template-columns: repeat(2, 1fr) !important;
//       gap: 12px !important;
//     }
    
//     /* Payment Page - 3 cols → 1 col */
//     div[style*="repeat(3, 1fr)"] {
//       grid-template-columns: 1fr !important;
//     }
    
//     /* Header flex containers - stack vertically */
//     div[style*="justify-content: space-between"][style*="align-items: center"] {
//       flex-direction: column !important;
//       gap: 12px !important;
//       align-items: stretch !important;
//     }
    
//     /* Buttons - full width on mobile */
//     button {
//       min-width: unset !important;
//     }
    
//     /* User info box in ChapterExamSelector header */
//     div[style*="position: absolute"][style*="top: 14px"] {
//       position: relative !important;
//       top: unset !important;
//       right: unset !important;
//       justify-content: center !important;
//       margin-bottom: 12px !important;
//     }
    
//     /* Reduce padding on cards */
//     div[style*="padding: 40px"] {
//       padding: 20px !important;
//     }
    
//     div[style*="padding: 32px"] {
//       padding: 16px !important;
//     }
    
//     /* Smaller titles */
//     h1[style*="font-size: 36px"] {
//       font-size: 24px !important;
//     }
    
//     h2[style*="font-size: 28px"] {
//       font-size: 20px !important;
//     }
//   }
  
//   @media (max-width: 480px) {
//     /* Extra small screens - everything single column */
//     div[style*="grid-template-columns: 1fr 1fr 1fr 1fr"],
//     div[style*="grid-template-columns: 1fr 1fr"] {
//       grid-template-columns: 1fr !important;
//     }
    
//     /* Even smaller padding */
//     div[style*="padding: 24px"] {
//       padding: 12px !important;
//     }
//   }
// `;

// ============= ADD THESE RULES TO YOUR EXISTING mobileResponsiveCSS =============
// Find your existing mobileResponsiveCSS constant and ADD these rules inside it

// const mobileResponsiveCSS = `
//   /* ========== GLOBAL OVERFLOW FIX ========== */
//   html, body {
//     max-width: 100%;
//     overflow-x: hidden !important;
//   }
//     /* ========== YOUR EXISTING CSS (KEEP AS IS) ========== */
  
//   @media (max-width: 768px) {
//     /* ChapterExamSelector - Exam Type Grid: 4 cols → 2 cols */
//     div[style*="grid-template-columns: 1fr 1fr 1fr 1fr"] {
//       grid-template-columns: repeat(2, 1fr) !important;
//       gap: 12px !important;
//     }
    
//     /* Payment Page - 3 cols → 1 col */
//     div[style*="repeat(3, 1fr)"] {
//       grid-template-columns: 1fr !important;
//     }
    
//     /* Header flex containers - stack vertically */
//     div[style*="justify-content: space-between"][style*="align-items: center"] {
//       flex-direction: column !important;
//       gap: 12px !important;
//       align-items: stretch !important;
//     }
    
//     /* Buttons - full width on mobile */
//     button {
//       min-width: unset !important;
//     }
    
//     /* User info box in ChapterExamSelector header */
//     div[style*="position: absolute"][style*="top: 14px"] {
//       position: relative !important;
//       top: unset !important;
//       right: unset !important;
//       justify-content: center !important;
//       margin-bottom: 12px !important;
//     }
    
//     /* Reduce padding on cards */
//     div[style*="padding: 40px"] {
//       padding: 20px !important;
//     }
    
//     div[style*="padding: 32px"] {
//       padding: 16px !important;
//     }
    
//     /* Smaller titles */
//     h1[style*="font-size: 36px"] {
//       font-size: 24px !important;
//     }
    
//     h2[style*="font-size: 28px"] {
//       font-size: 20px !important;
//     }
    
//     /* ========== ADD THESE NEW RULES BELOW ========== */
    
//     /* Landing page domain header */
//     p[style*="fontSize: '44px'"] {
//       font-size: 22px !important;
//       line-height: 1.3 !important;
//       word-break: break-word !important;
//     }
    
//     /* Landing page two-column grids */
//     div[style*="gridTemplateColumns"][style*="window.innerWidth > 968"] {
//       grid-template-columns: 1fr !important;
//     }
    
//     /* Landing page box titles */
//     h2[style*="fontSize: '24px'"] {
//       font-size: 20px !important;
//     }
    
//     /* Landing page box subtitles */
//     p[style*="fontSize: '16px'"][style*="fontStyle: 'italic'"] {
//       font-size: 14px !important;
//     }
    
//     /* Feature list text */
//     ul[style*="fontSize: '14px'"] {
//       font-size: 13px !important;
//       line-height: 1.6 !important;
//     }
//     /* Global overflow fix */
// html, body {
//   max-width: 100%;
//   overflow-x: hidden !important;
// }

// /* Desktop menu class */
// .nav-menu-desktop {
//   display: flex !important;
//   align-items: center;
//   gap: 8px;
//   flex-wrap: wrap;
// }

// /* Mobile button class */
// .nav-menu-mobile-btn {
//   display: none !important;
// }

// /* Hide desktop, show mobile button */
// /* Hide desktop menu on mobile, show mobile button */
//   @media (max-width: 900px) {
//     .nav-menu-desktop {
//       display: none !important;
//     }
    
//     .nav-menu-mobile-btn {
//       display: block !important;
//       background: #777777;
//       border: none;
//       border-radius: 6px;
//       padding: 10px 16px;
//       color: #FFFF00;
//       font-size: 20px;
//       cursor: pointer;
//     }
    
//     /* Navigation container */
//     nav {
//       padding: 0 12px !important;
//       overflow-x: hidden !important;
//     }
    
//     /* Logo smaller on mobile */
//     nav > div > a {
//       font-size: 18px !important;
//     }
//   }
//     /* Badges (ACTIVE, COMING SOON) */
//     div[style*="position: 'absolute'"][style*="top: '2px'"] {
//       padding: 4px 20px !important;
//       font-size: 11px !important;
//       right: -10px !important;
//     }
//   }
  
//   /* ========== NAVIGATION RESPONSIVE (900px breakpoint) ========== */
//   @media (max-width: 900px) {
//     /* Stack nav vertically */
//     nav > div {
//       flex-direction: column !important;
//       height: auto !important;
//       padding: 12px 0 !important;
//       gap: 12px !important;
//     }
    
//     /* Center logo */
//     nav > div > a {
//       align-self: center !important;
//     }
    
//     /* Menu items container - stack vertically */
//     nav > div > div:last-child {
//       display: flex !important;
//       flex-direction: column !important;
//       width: 100% !important;
//       padding: 0 12px !important;
//     }
    
//     /* Full width nav buttons */
//     nav > div > div:last-child > * {
//       width: 100% !important;
//       justify-content: center !important;
//     }
    
//     /* Nav button text */
//     nav button,
//     nav a[style*="padding"] {
//       font-size: 15px !important;
//       padding: 10px 14px !important;
//     }
    
//     /* Dropdowns - position relative on mobile */
//     .practice-dropdown,
//     .guides-dropdown,
//     .blog-dropdown {
//       position: relative !important;
//       margin-top: 4px !important;
//       left: 0 !important;
//       width: 100% !important;
//     }
//   }
  
//   @media (max-width: 480px) {
//     /* Extra small screens - everything single column */
//     div[style*="grid-template-columns: 1fr 1fr 1fr 1fr"],
//     div[style*="grid-template-columns: 1fr 1fr"] {
//       grid-template-columns: 1fr !important;
//     }
    
//     /* Even smaller padding */
//     div[style*="padding: 24px"] {
//       padding: 12px !important;
//     }
    
//     /* ========== ADD THESE NEW RULES BELOW ========== */
    
//     /* Extra small domain header */
//     p[style*="fontSize: '44px'"] {
//       font-size: 18px !important;
//     }
    
//     /* Extra small headings */
//     h2[style*="fontSize: '24px'"] {
//       font-size: 18px !important;
//     }
    
//     /* Smaller nav on tiny screens */
//     nav > div > a {
//       font-size: 16px !important;
//     }
    
//     nav button,
//     nav a[style*="padding"] {
//       font-size: 13px !important;
//       padding: 8px 12px !important;
//     }
//   }
// `;

// ============= COMPLETE MOBILE RESPONSIVE CSS =============
// Copy this ENTIRE constant and replace your existing mobileResponsiveCSS

const mobileResponsiveCSS = `
  /* ========== GLOBAL OVERFLOW FIX ========== */
  html, body {
    max-width: 100%;
    overflow-x: hidden !important;
  }
  
  /* ========== NAVIGATION CLASSES ========== */
  
  /* Desktop menu - visible by default */
  .nav-menu-desktop {
    display: flex !important;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  
  /* Mobile menu button - hidden by default */
  .nav-menu-mobile-btn {
    display: none !important;
  }
  
  /* ========== MOBILE RESPONSIVE (768px and below) ========== */
  
  @media (max-width: 768px) {
    /* ChapterExamSelector - Exam Type Grid: 4 cols → 2 cols */
    div[style*="grid-template-columns: 1fr 1fr 1fr 1fr"] {
      grid-template-columns: repeat(2, 1fr) !important;
      gap: 12px !important;
    }
    
    /* Payment Page - 3 cols → 1 col */
    div[style*="repeat(3, 1fr)"] {
      grid-template-columns: 1fr !important;
    }
    
    /* Header flex containers - stack vertically */
    div[style*="justify-content: space-between"][style*="align-items: center"] {
      flex-direction: column !important;
      gap: 12px !important;
      align-items: stretch !important;
    }
    
    /* Buttons - full width on mobile */
    button {
      min-width: unset !important;
    }
    
    /* User info box in ChapterExamSelector header */
    div[style*="position: absolute"][style*="top: 14px"] {
      position: relative !important;
      top: unset !important;
      right: unset !important;
      justify-content: center !important;
      margin-bottom: 12px !important;
    }
    
    /* Reduce padding on cards */
    div[style*="padding: 40px"] {
      padding: 20px !important;
    }
    
    div[style*="padding: 32px"] {
      padding: 16px !important;
    }
    
    /* Smaller titles */
    h1[style*="font-size: 36px"] {
      font-size: 24px !important;
    }
    
    h2[style*="font-size: 28px"] {
      font-size: 20px !important;
    }
    
    /* ========== LANDING PAGE SPECIFIC ========== */
    
    /* Domain header text wrapping */
    p[style*="fontSize: '44px'"] {
      font-size: 22px !important;
      line-height: 1.3 !important;
      word-break: break-word !important;
      padding: 0 10px !important;
    }
    
    /* Landing page two-column grids */
    div[style*="gridTemplateColumns"][style*="window.innerWidth > 968"] {
      grid-template-columns: 1fr !important;
    }
    
    /* Landing page box titles */
    h2[style*="fontSize: '24px'"] {
      font-size: 20px !important;
    }
    
    /* Landing page box subtitles */
    p[style*="fontSize: '16px'"][style*="fontStyle: 'italic'"] {
      font-size: 14px !important;
    }
    
    /* Feature list text */
    ul[style*="fontSize: '14px'"] {
      font-size: 13px !important;
      line-height: 1.6 !important;
    }
    
    /* Badges (ACTIVE, COMING SOON) */
    div[style*="position: 'absolute'"][style*="top: '2px'"] {
      padding: 4px 20px !important;
      font-size: 11px !important;
      right: -10px !important;
    }
  }
  
  /* ========== NAVIGATION RESPONSIVE (900px and below) ========== */
  
  @media (max-width: 900px) {
    /* Hide desktop menu, show mobile button */
    .nav-menu-desktop {
      display: none !important;
    }
    
    .nav-menu-mobile-btn {
      display: block !important;
      background: #777777;
      border: none;
      border-radius: 6px;
      padding: 10px 16px;
      color: #FFFF00;
      font-size: 20px;
      cursor: pointer;
    }
    
    /* Navigation container */
    nav {
      padding: 0 12px !important;
      overflow-x: hidden !important;
    }
    
    /* Logo smaller on mobile */
    nav > div > a {
      font-size: 18px !important;
    }
    
    /* Stack navigation vertically */
    nav > div {
      flex-direction: row !important;
      justify-content: space-between !important;
      height: 64px !important;
      padding: 0 12px !important;
    }
  }
  
  /* ========== EXTRA SMALL SCREENS (480px and below) ========== */
  
  @media (max-width: 480px) {
    /* Extra small screens - everything single column */
    div[style*="grid-template-columns: 1fr 1fr 1fr 1fr"],
    div[style*="grid-template-columns: 1fr 1fr"] {
      grid-template-columns: 1fr !important;
    }
    
    /* Even smaller padding */
    div[style*="padding: 24px"] {
      padding: 12px !important;
    }
    
    /* Extra small domain header */
    p[style*="fontSize: '44px'"] {
      font-size: 18px !important;
    }
    
    /* Extra small headings */
    h2[style*="fontSize: '24px'"] {
      font-size: 18px !important;
    }
    
    /* Smaller nav on tiny screens */
    nav > div > a {
      font-size: 16px !important;
    }
    
    nav {
      padding: 0 8px !important;
    }
    
    .nav-menu-mobile-btn {
      font-size: 18px !important;
      padding: 8px 12px !important;
    }
  }
`;
  // Landing Page - RESPONSIVE TWO COLUMN LAYOUT
  // Landing Page - NEW LAYOUT
if (currentPage === 'landing') {
  
  return (
    <div style={styles.container}>
      {/* ============= INLINE NAVIGATION MENU (PASTE IN APP.JS) ============= */}
{/* Add this at the VERY TOP of your landing page, before everything else */}
{/* MOBILE-RESPONSIVE NAVIGATION */}
<>
  <style>{`
    .mobile-nav-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 999;
      opacity: ${mobileMenuOpen ? '1' : '0'};
      visibility: ${mobileMenuOpen ? 'visible' : 'hidden'};
      transition: opacity 0.3s ease, visibility 0.3s ease;
    }

    .mobile-nav-drawer {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      width: 85%;
      max-width: 400px;
      background: #ffffff;
      z-index: 1000;
      transform: translateX(${mobileMenuOpen ? '0' : '100%'});
      transition: transform 0.3s ease;
      overflow-y: auto;
      box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 968px) {
      .desktop-nav { display: none !important; }
      .mobile-menu-btn { display: flex !important; }
      .two-column-grid { grid-template-columns: 1fr !important; }
    }
    @media (min-width: 969px) {
      .desktop-nav { display: flex !important; }
      .mobile-menu-btn { display: none !important; }
    }
    @media (max-width: 480px) {
      .landing-title { font-size: 28px !important; }
    }
  `}</style>

  {/* Overlay */}
  <div className="mobile-nav-overlay" onClick={() => setMobileMenuOpen(false)} />
  
  {/* Mobile Drawer */}
  <div className="mobile-nav-drawer">
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px',
      borderBottom: '1px solid #e5e7eb'
    }}>
      <span style={{fontSize: '20px', fontWeight: '700', color: '#111827'}}>
        ☕ JavaLearn
      </span>
      <button
        onClick={() => setMobileMenuOpen(false)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '8px'
        }}
      >
        <X size={24} color="#111827" />
      </button>
    </div>

    {/* Home Link */}
    <div style={{borderBottom: '1px solid #f3f4f6'}}>
      <a href="/" style={{
        display: 'block',
        padding: '16px 20px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#111827',
        textDecoration: 'none'
      }}>
        Home
      </a>
    </div>

    {/* Practice Tests Dropdown */}
    <div style={{borderBottom: '1px solid #f3f4f6'}}>
      <button
        onClick={() => setMobilePracticeOpen(!mobilePracticeOpen)}
        style={{
          width: '100%',
          padding: '16px 20px',
          textAlign: 'left',
          background: 'none',
          border: 'none',
          fontSize: '16px',
          fontWeight: '500',
          color: '#111827',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span>Java 8 OCA Free Practice Tests</span>
        <span style={{fontSize: '12px'}}>{mobilePracticeOpen ? '▲' : '▼'}</span>
      </button>
      <div style={{
        background: '#f9fafb',
        maxHeight: mobilePracticeOpen ? '500px' : '0',
        overflow: 'hidden',
        transition: 'max-height 0.3s ease'
      }}>
        {[1,2,3,4,5,6,7,8,9].map(num => (
          <a key={num} href={`/oca-java-8-practice-test-${num}`} target="_blank" rel="noopener noreferrer" style={{
            display: 'block',
            padding: '12px 20px 12px 40px',
            fontSize: '14px',
            color: '#374151',
            textDecoration: 'none',
            borderBottom: '1px solid #e5e7eb'
          }}>
            Java 8 OCA free practice test : {num}
          </a>
        ))}
      </div>
    </div>

    {/* Guides Dropdown */}
    <div style={{borderBottom: '1px solid #f3f4f6'}}>
      <button
        onClick={() => setMobileGuidesOpen(!mobileGuidesOpen)}
        style={{
          width: '100%',
          padding: '16px 20px',
          textAlign: 'left',
          background: 'none',
          border: 'none',
          fontSize: '16px',
          fontWeight: '500',
          color: '#111827',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span>Java 8 OCA Guides</span>
        <span style={{fontSize: '12px'}}>{mobileGuidesOpen ? '▲' : '▼'}</span>
      </button>
      <div style={{
        background: '#f9fafb',
        maxHeight: mobileGuidesOpen ? '500px' : '0',
        overflow: 'hidden',
        transition: 'max-height 0.3s ease'
      }}>
        <a href="/oca-java-syllabus-detailed" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>
          Complete OCA Syllabus
        </a>
        <a href="/oca-java-exam-pattern" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>
          Exam Pattern & Format
        </a>
        <a href="/how-to-pass-oca-java-first-attempt" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>
          How to Pass First Attempt
        </a>
        <a href="/oca-ocp-java-syllabus" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>
          OCA vs OCP Comparison
        </a>
        <a href="/is-oca-java-worth-it" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>
          Is OCA Worth It?
        </a>
       {/* ADD THIS ↓ */}
<a href="/how-to-register-oca-exam" target="_blank" rel="noopener noreferrer" style={{
  display: 'block',
  padding: '12px 20px 12px 40px',
  fontSize: '14px',
  color: '#374151',
  textDecoration: 'none',
  borderBottom: '1px solid #e5e7eb'
}}>
  How to Register for OCA Exam
</a>
      </div>
    </div>

    {/* Blog Dropdown */}
    <div style={{borderBottom: '1px solid #f3f4f6'}}>
      <button
        onClick={() => setMobileBlogOpen(!mobileBlogOpen)}
        style={{
          width: '100%',
          padding: '16px 20px',
          textAlign: 'left',
          background: 'none',
          border: 'none',
          fontSize: '16px',
          fontWeight: '500',
          color: '#111827',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span>Blog</span>
        <span style={{fontSize: '12px'}}>{mobileBlogOpen ? '▲' : '▼'}</span>
      </button>
      <div style={{
        background: '#f9fafb',
        maxHeight: mobileBlogOpen ? '500px' : '0',
        overflow: 'hidden',
        transition: 'max-height 0.3s ease'
      }}>
        <a href="/blog-videos" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>
          📺 Video Tutorials
        </a>
        <a href="/blog-articles" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>
          📄 Articles
        </a>
      </div>
    </div>

    {/* Start Free Trial Button */}
    <a
      href="https://javalearn.clustermicro.com"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'block',
        margin: '20px',
        padding: '14px 24px',
        background: '#16a34a',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        textAlign: 'center',
        textDecoration: 'none',
        width: 'calc(100% - 40px)'
      }}
    >
      Start Free Trial
    </a>
  </div>

  {/* Navigation Bar */}
 <>
  <style>{`
    .mobile-nav-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 999;
      opacity: ${mobileMenuOpen ? '1' : '0'};
      visibility: ${mobileMenuOpen ? 'visible' : 'hidden'};
      transition: opacity 0.3s ease, visibility 0.3s ease;
    }

    .mobile-nav-drawer {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      width: 85%;
      max-width: 400px;
      background: #ffffff;
      z-index: 1000;
      transform: translateX(${mobileMenuOpen ? '0' : '100%'});
      transition: transform 0.3s ease;
      overflow-y: auto;
      box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 968px) {
      .desktop-nav { display: none !important; }
      .mobile-menu-btn { display: flex !important; }
      .two-column-grid { grid-template-columns: 1fr !important; }
    }
    @media (min-width: 969px) {
      .desktop-nav { display: flex !important; }
      .mobile-menu-btn { display: none !important; }
    }
  `}</style>

  {/* Mobile Overlay */}
  <div className="mobile-nav-overlay" onClick={() => setMobileMenuOpen(false)} />
  
  {/* Mobile Drawer */}
  <div className="mobile-nav-drawer">
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px',
      borderBottom: '1px solid #e5e7eb'
    }}>
      <span style={{fontSize: '20px', fontWeight: '700', color: '#111827'}}>
        ☕ JavaLearn
      </span>
      <button
        onClick={() => setMobileMenuOpen(false)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '8px'
        }}
      >
        <X size={24} color="#111827" />
      </button>
    </div>

    {/* Mobile: Home */}
    <div style={{borderBottom: '1px solid #f3f4f6'}}>
      <a href="/" style={{
        display: 'block',
        padding: '16px 20px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#111827',
        textDecoration: 'none'
      }}>
        Home
      </a>
    </div>

    {/* Mobile: Practice Tests */}
    <div style={{borderBottom: '1px solid #f3f4f6'}}>
      <button
        onClick={() => setMobilePracticeOpen(!mobilePracticeOpen)}
        style={{
          width: '100%',
          padding: '16px 20px',
          textAlign: 'left',
          background: 'none',
          border: 'none',
          fontSize: '16px',
          fontWeight: '500',
          color: '#111827',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span>Java 8 OCA Free Practice Tests</span>
        <span style={{fontSize: '12px'}}>{mobilePracticeOpen ? '▲' : '▼'}</span>
      </button>
      <div style={{
        background: '#f9fafb',
        maxHeight: mobilePracticeOpen ? '500px' : '0',
        overflow: 'hidden',
        transition: 'max-height 0.3s ease'
      }}>
        {[1,2,3,4,5,6,7,8,9].map(num => (
          <a key={num} href={`/oca-java-8-practice-test-${num}`} target="_blank" rel="noopener noreferrer" style={{
            display: 'block',
            padding: '12px 20px 12px 40px',
            fontSize: '14px',
            color: '#374151',
            textDecoration: 'none',
            borderBottom: '1px solid #e5e7eb'
          }}>
            Java 8 OCA free practice test : {num}
          </a>
        ))}
      </div>
    </div>

    {/* Mobile: Guides */}
    <div style={{borderBottom: '1px solid #f3f4f6'}}>
      <button
        onClick={() => setMobileGuidesOpen(!mobileGuidesOpen)}
        style={{
          width: '100%',
          padding: '16px 20px',
          textAlign: 'left',
          background: 'none',
          border: 'none',
          fontSize: '16px',
          fontWeight: '500',
          color: '#111827',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span>Java 8 OCA Guides</span>
        <span style={{fontSize: '12px'}}>{mobileGuidesOpen ? '▲' : '▼'}</span>
      </button>
      <div style={{
        background: '#f9fafb',
        maxHeight: mobileGuidesOpen ? '500px' : '0',
        overflow: 'hidden',
        transition: 'max-height 0.3s ease'
      }}>
        <a href="/oca-java-syllabus-detailed" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>Complete OCA Syllabus</a>
        <a href="/oca-java-exam-pattern" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>Exam Pattern & Format</a>
        <a href="/how-to-pass-oca-java-first-attempt" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>How to Pass First Attempt</a>
        <a href="/oca-ocp-java-syllabus" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>OCA vs OCP Comparison</a>
        <a href="/is-oca-java-worth-it" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>Is OCA Worth It?</a>
        {/* ADD THIS ↓ */}
<a href="/how-to-register-oca-exam" target="_blank" rel="noopener noreferrer" style={{
  display: 'block',
  padding: '12px 20px 12px 40px',
  fontSize: '14px',
  color: '#374151',
  textDecoration: 'none',
  borderBottom: '1px solid #e5e7eb'
}}>
  How to Register for OCA Exam
</a>
      </div>
    </div>

    {/* Mobile: Blog */}
    <div style={{borderBottom: '1px solid #f3f4f6'}}>
      <button
        onClick={() => setMobileBlogOpen(!mobileBlogOpen)}
        style={{
          width: '100%',
          padding: '16px 20px',
          textAlign: 'left',
          background: 'none',
          border: 'none',
          fontSize: '16px',
          fontWeight: '500',
          color: '#111827',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span>Blog</span>
        <span style={{fontSize: '12px'}}>{mobileBlogOpen ? '▲' : '▼'}</span>
      </button>
      <div style={{
        background: '#f9fafb',
        maxHeight: mobileBlogOpen ? '500px' : '0',
        overflow: 'hidden',
        transition: 'max-height 0.3s ease'
      }}>
        <a href="/blog-videos" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>📺 Video Tutorials</a>
        <a href="/blog-articles" target="_blank" rel="noopener noreferrer" style={{
          display: 'block',
          padding: '12px 20px 12px 40px',
          fontSize: '14px',
          color: '#374151',
          textDecoration: 'none',
          borderBottom: '1px solid #e5e7eb'
        }}>📄 Articles</a>
      </div>
    </div>

    {/* Mobile: Start Free Trial */}
 <button
  onClick={() => {
    setMobileMenuOpen(false);
    setCurrentPage('register');
  }}
  style={{
    display: 'block',
    margin: '20px',
    padding: '14px 24px',
    background: '#16a34a',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    textAlign: 'center',
    cursor: 'pointer',
    width: 'calc(100% - 40px)'
  }}
>
  Start Free Trial
</button>
  </div>

  {/* Navigation Bar */}
  <nav style={{
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e5e7eb',
    padding: '0 20px',
    position: 'sticky',
    top: 0,
    zIndex: 998,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
  }}>
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '64px'
    }}>
      
      {/* Logo */}
      <a href="/" style={{
        fontSize: '24px',
        fontWeight: '700',
        color: '#0f1010',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <span>☕</span>
        <span>JavaLearn</span>
      </a>

      {/* Desktop Menu */}
      <div className="desktop-nav" style={{
        display: 'none',
        alignItems: 'center',
        gap: '8px'
      }}>
        {/* Home */}
        <a href="/" style={{
          padding: '10px 16px',
          fontSize: '16px',
          border: 'none',
          fontWeight: '500',
          backgroundColor: '#ffffff',
          color: '#0b0b0b',
          textDecoration: 'none',
          borderRadius: '6px',
          transition: 'all 0.2s'
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#8dfc9f'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}>
          Home
        </a>

        {/* Practice Dropdown */}
        <div style={{ position: 'relative' }}
          onMouseEnter={(e) => {
            const dropdown = e.currentTarget.querySelector('.practice-dropdown');
            if (dropdown) dropdown.style.display = 'block';
          }}
          onMouseLeave={(e) => {
            const dropdown = e.currentTarget.querySelector('.practice-dropdown');
            if (dropdown) dropdown.style.display = 'none';
          }}>
          
          <button style={{
            padding: '10px 16px',
            backgroundColor: '#ffffff',
            border: 'none',
            borderRadius: '6px',
            fontSize: '16px',
            fontWeight: '300',
            color: '#0b0b0b',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}> 
            Java 8 OCA Free Practice Tests<span style={{ fontSize: '12px' }}>▼</span>
          </button>

          <div className="practice-dropdown" style={{
            display: 'none',
            position: 'absolute',
            top: '100%',
            left: 0,
            backgroundColor: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            minWidth: '260px',
            padding: '8px',
            zIndex: 1001
          }}>
            {[1,2,3,4,5,6,7,8,9].map(num => (
              <a key={num} href={`/oca-java-8-practice-test-${num}`} target="_blank" rel="noopener noreferrer" style={{
                display: 'block', padding: '12px 16px', fontSize: '14px',
                color: '#374151', textDecoration: 'none', borderRadius: '4px'
              }}
              onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0fdf4'; e.currentTarget.style.color = '#16a34a'; }}
              onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#374151'; }}>
                Java 8 OCA free practice test : {num}
              </a>
            ))}
          </div>
        </div>

        {/* Guides Dropdown */}
        <div style={{ position: 'relative' }}
          onMouseEnter={(e) => {
            const dropdown = e.currentTarget.querySelector('.guides-dropdown');
            if (dropdown) dropdown.style.display = 'block';
          }}
          onMouseLeave={(e) => {
            const dropdown = e.currentTarget.querySelector('.guides-dropdown');
            if (dropdown) dropdown.style.display = 'none';
          }}>
          
          <button style={{
            padding: '10px 16px',
            backgroundColor: '#ffffff',
            border: 'none',
            borderRadius: '6px',
            fontSize: '16px',
            fontWeight: '300',
            color: '#0b0b0b',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}> 
            Java 8 OCA Guides <span style={{ fontSize: '12px' }}>▼</span>
          </button>

          <div className="guides-dropdown" style={{
            display: 'none',
            position: 'absolute',
            top: '100%',
            left: 0,
            backgroundColor: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            minWidth: '260px',
            padding: '8px',
            zIndex: 1001
          }}>
            <a href="/oca-java-syllabus-detailed" target="_blank" rel="noopener noreferrer" style={{
              display: 'block', padding: '12px 16px', fontSize: '14px',
              color: '#374151', textDecoration: 'none', borderRadius: '4px'
            }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0fdf4'; e.currentTarget.style.color = '#16a34a'; }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#374151'; }}>
              Complete OCA Syllabus
            </a>
            <a href="/oca-java-exam-pattern" target="_blank" rel="noopener noreferrer" style={{
              display: 'block', padding: '12px 16px', fontSize: '14px',
              color: '#374151', textDecoration: 'none', borderRadius: '4px'
            }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0fdf4'; e.currentTarget.style.color = '#16a34a'; }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#374151'; }}>
              Exam Pattern & Format
            </a>
            <a href="/how-to-pass-oca-java-first-attempt" target="_blank" rel="noopener noreferrer" style={{
              display: 'block', padding: '12px 16px', fontSize: '14px',
              color: '#374151', textDecoration: 'none', borderRadius: '4px'
            }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0fdf4'; e.currentTarget.style.color = '#16a34a'; }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#374151'; }}>
              How to Pass First Attempt
            </a>
            <a href="/oca-ocp-java-syllabus" target="_blank" rel="noopener noreferrer" style={{
              display: 'block', padding: '12px 16px', fontSize: '14px',
              color: '#374151', textDecoration: 'none', borderRadius: '4px'
            }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0fdf4'; e.currentTarget.style.color = '#16a34a'; }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#374151'; }}>
              OCA vs OCP Comparison
            </a>
            <a href="/is-oca-java-worth-it" target="_blank" rel="noopener noreferrer" style={{
              display: 'block', padding: '12px 16px', fontSize: '14px',
              color: '#374151', textDecoration: 'none', borderRadius: '4px'
            }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0fdf4'; e.currentTarget.style.color = '#16a34a'; }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#374151'; }}>
              Is OCA Worth It?
            </a>
            {/* ADD THIS ↓ */}
<a href="/how-to-register-oca-exam" target="_blank" rel="noopener noreferrer" style={{
  display: 'block', padding: '12px 16px', fontSize: '14px',
  color: '#374151', textDecoration: 'none', borderRadius: '4px'
}}
onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0fdf4'; e.currentTarget.style.color = '#16a34a'; }}
onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#374151'; }}>
  How to Register for OCA Exam
</a>
          </div>
        </div>

        {/* Blog Dropdown */}
        <div style={{ position: 'relative' }}
          onMouseEnter={(e) => {
            const dropdown = e.currentTarget.querySelector('.blog-dropdown');
            if (dropdown) dropdown.style.display = 'block';
          }}
          onMouseLeave={(e) => {
            const dropdown = e.currentTarget.querySelector('.blog-dropdown');
            if (dropdown) dropdown.style.display = 'none';
          }}>
          
          <button style={{ 
            padding: '10px 16px',
            backgroundColor: '#ffffff',
            border: 'none',
            borderRadius: '6px',
            fontSize: '16px',
            fontWeight: '300',
            color: '#0b0b0b',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}> 
            Blog <span style={{ fontSize: '12px' }}>▼</span>
          </button>

          <div className="blog-dropdown" style={{
            display: 'none',
            position: 'absolute',
            top: '100%',
            left: 0,
            backgroundColor: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            minWidth: '200px',
            padding: '8px',
            zIndex: 1001
          }}>
            <a href="/blog-videos" target="_blank" rel="noopener noreferrer" style={{
              display: 'block', padding: '12px 16px', fontSize: '14px',
              color: '#374151', textDecoration: 'none', borderRadius: '4px'
            }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0fdf4'; e.currentTarget.style.color = '#16a34a'; }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#374151'; }}>
              📺 Video Tutorials
            </a>
            <a href="/blog-articles" target="_blank" rel="noopener noreferrer" style={{
              display: 'block', padding: '12px 16px', fontSize: '14px',
              color: '#374151', textDecoration: 'none', borderRadius: '4px'
            }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0fdf4'; e.currentTarget.style.color = '#16a34a'; }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#374151'; }}>
              📄 Articles
            </a>
          </div>
        </div>

        {/* Start Free Trial */}
    <button
  onClick={() => setCurrentPage('register')}
  style={{
    padding: '10px 24px',
    backgroundColor: '#ffffff',
    color: '#0e0e0e',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: '300',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s',
    marginLeft: '8px'
  }}
  onMouseOver={(e) => {
    e.currentTarget.style.backgroundColor = '#90f661';
    e.currentTarget.style.transform = 'translateY(-1px)';
  }}
  onMouseOut={(e) => {
    e.currentTarget.style.backgroundColor = '#ffffff';
    e.currentTarget.style.transform = 'translateY(0)';
  }}
>
  Start Free Trial
</button>
      </div>

      {/* Mobile Menu Button */}
      <button
        className="mobile-menu-btn"
        onClick={() => setMobileMenuOpen(true)}
        style={{
          display: 'none',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px',
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }}
      >
        <Menu size={28} color="#111827" />
      </button>
    </div>
  </nav>
</>
</>

      <style>{`
        @media (max-width: 968px) {
          .two-column-grid {
            grid-template-columns: 1fr !important;
            gap: 24px !important;
          }
          .full-width-header {
            padding: 40px 20px 0 20px !important;
          }
        }
        @media (max-width: 480px) {
          .header-logo-section {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 8px !important;
          }
          .header-logo {
            width: 64px !important;
            height: 64px !important;
          }
          .header-domain {
            font-size: 20px !important;
          }
          .header-title {
            font-size: 22px !important;
          }
          .header-maintenance {
            font-size: 16px !important;
          }
          .header-description {
            font-size: 15px !important;
          }
        }
      `}</style>
      
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '18px 20px'
      }}>
        
        {/* FULL WIDTH HEADER */}
        {/* ============= DOMAIN HEADER ============= */}
{/* DOMAIN HEADER */}
<div style={{
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '24px 20px',
  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
  border: '1px solid rgba(0,0,0,0.08)',
  textAlign: 'center',
  marginBottom: '18px'
}}>
  <p style={{
    fontSize: window.innerWidth <= 480 ? '20px' : window.innerWidth <= 768 ? '28px' : '44px',
    margin: 0,
    fontWeight: '500',
    color: '#111827',
    fontFamily: '"Segoe UI", Roboto, sans-serif',
    letterSpacing: '-0.3px',
    lineHeight: '1.2',
    wordBreak: 'break-word',
    overflowWrap: 'break-word'
  }}>
    <span style={{ color: '#100f0f' }}>Java</span>
    <span style={{ color: '#e01b1b' }}>learn</span>
    <span style={{ color: '#e01b1b' }}>.clustermicro.com</span>
  </p>
</div>

{/* ============= TWO BOX LAYOUT: OCA | OCP ============= */}
<div style={{
  display: 'grid',
  gridTemplateColumns: window.innerWidth > 968 ? '1fr 1fr' : '1fr',
  gap: '18px',
  marginBottom: '18px'
}}>

  {/* ========== LEFT BOX: OCA (Java SE 8) ========== */}
  <div style={{
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '32px',
    boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
    border: '2px solid #ffffff',
    position: 'relative'
  }}>
    {/* "ACTIVE" Badge */}
    <div style={{
      position: 'absolute',
      top: '2px',
      right: '-1px',
       backgroundColor: '#3bba27',
      color: '#ffffff',
      padding: '6px 45px',
      // transform: 'rotate(45deg)',
      fontSize: '14px',
      fontWeight: 'bold',
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      letterSpacing: '1px'
    }}>
      LIVE, THIS SITE
    </div>

    {/* Title */}
    <h2 style={{
      fontSize: '24px',
      fontWeight: 'bold',
      margin: '0 0 16px 0',
      lineHeight: '1.3',
      color: '#000000'
    }}>
      Master Java SE 8 Certification OCAJP 8 1Z0-808
    </h2>

    {/* Subtitle */}
    <p style={{
      fontSize: '16px',
      color: '#6b7280',
      marginBottom: '20px',
      fontStyle: 'italic'
    }}>
      Prepare with confidence through our comprehensive practice exams
    </p>

    {/* Features List */}
    <div style={{
      backgroundColor: '#ffffff',
      padding: '20px',
      borderRadius: '10px',
      borderLeft: '5px solid #f44611'
      // borderRight: '5px solid #f44611'
    }}>
      <ul style={{
        listStyle: 'disc',
        paddingLeft: '20px',
        lineHeight: '1.8',
        color: '#121212',
        fontSize: '14px',
        margin: 0
      }}>
        <li>1,624 practice questions with detailed explanations</li>
        <li>Timed exams simulating real certification tests</li>
        <li>29 full-length practice tests available</li>
        <li>Fully cloud-native platform using modern databases</li>
        <li>Single Page Application (SPA) for faster load times</li>
        <li>Smoother navigation than traditional web apps</li>
        <li>Well-reviewed questions for effective learning</li>
        <li>Attendance tracking and completion certificates</li>
      </ul>
    </div>

    {/* CTA Button */}
    <div style={{
      marginTop: '20px',
      textAlign: 'center'
    }}>
      {/* Call to Action */}
    <div style={{
      textAlign: 'center',
      padding: '16px',
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      borderLeft: '5px solid #777777'
    }}>
      <p style={{
        fontSize: '18px',
        color: '#101111',
        margin: '0 0 8px 0',
        fontWeight: '600'
      }}>
        📧 OCA  Practice Exams are active, Please create an account
      </p>
      
    </div>
      {/* <button
        onClick={() => setCurrentPage('register')}
        style={{
          padding: '12px 32px',
          background: 'linear-gradient(135deg, #edf1f8 0%, #e3e8f1 100%)',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '15px',
          fontWeight: '600',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
          transition: 'transform 0.2s ease'
        }}
        onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
        onMouseOut={(e) => e.currentTarget.style.transform = 'none'}
      >
        Start Practicing Now →
      </button> */}
    </div>
  </div>
{/* ========== RIGHT BOX: OCP (Java SE 17 & 21) - NOW LIVE ========== */}
<div style={{
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '32px',
  boxShadow: '0 6px 20px rgba(16, 185, 129, 0.15)',
  border: '3px solid #ffffff',
  position: 'relative'
}}>
  {/* "NOW LIVE" Badge */}
  <div style={{
    position: 'absolute',
    top: '2px',
    right: '-1px',
    backgroundColor: '#16a34a',
    color: '#ffffff',
    padding: '6px 45px',
    fontSize: '14px',
    fontWeight: 'bold',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    letterSpacing: '1px'
  }}>
    🎉 NOW LIVE
  </div>

  {/* Title */}
  <h2 style={{
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#171818',
    margin: '0 0 8px 0'
  }}>
    JavaOCP is Live!
  </h2>

  {/* Subtitle */}
  <p style={{
    fontSize: '16px',
    color: '#6b7280',
    marginBottom: '20px'
  }}>
    Java SE 17 & 21 OCP Practice Platform
  </p>

  {/* Features List */}
  <div style={{
    backgroundColor: '#ffffff',
    padding: '20px',
    borderRadius: '10px',
    borderLeft: '5px solid #16a34a',
    marginBottom: '20px'
  }}>
    <h4 style={{
      fontSize: '14px',
      fontWeight: '600',
      color: '#0e0e0e',
      marginBottom: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    }}>
      <span style={{ fontSize: '18px' }}>🎓</span>
      What's Inside:
    </h4>

    <ul style={{
      fontSize: '14px',
      color: '#101111',
      lineHeight: '2',
      paddingLeft: '20px',
      margin: 0,
      listStyle: 'disc'
    }}>
      <li><strong>Java SE 17 OCP (1Z0-829)</strong></li>
      <li>1,884 practice questions</li>
      <li>37 full certification tests</li>
      <li style={{ marginTop: '8px' }}><strong>Java SE 21 OCP (1Z0-830)</strong></li>
      <li>2,074 practice questions</li>
      <li>41 full certification tests</li>
      <li style={{ marginTop: '8px' }}>Virtual Threads, Pattern Matching</li>
      <li>Sequenced Collections & more!</li>
      <li style={{ marginTop: '8px' }}><strong>From ₹1,400 / $16</strong></li>
    </ul>
  </div>

  {/* Call to Action */}
  <div style={{
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#f0fdf4',
    borderRadius: '8px',
    border: '2px solid #16a34a'
  }}>
    <p style={{
      fontSize: '14px',
      color: '#065f46',
      margin: '0 0 12px 0',
      fontWeight: '600'
    }}>
      🚀 Start practicing for OCP today!
    </p>    
    <a
      href="https://javaocp.clustermicro.com/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-block',
        padding: '12px 28px',
        backgroundColor: '#16a34a',
        color: '#ffffff',
        textDecoration: 'none',
        borderRadius: '8px',
        fontSize: '15px',
        fontWeight: '600',
        boxShadow: '0 2px 8px rgba(22, 163, 74, 0.3)'
      }}
    >
      Visit JavaOCP →
    </a>
    <p style={{
      fontSize: '12px',
      color: '#059669',
      margin: '12px 0 0 0',
      fontStyle: 'italic'
    }}>
      3 days free trial • No credit card required
    </p>
  </div>
</div>

</div> {/* End Two Box Layout */}

{/* ============= MOTIVATIONAL TEXT ============= */}
<div style={{
  backgroundColor: '#ffffff',
       
  borderRadius: '12px',
  padding: '20px 32px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  border: '1px solid rgba(0,0,0,0.08)',
  textAlign: 'center',
  marginBottom: '18px'
}}>
  <p style={{
    fontSize: '16px',
    lineHeight: '1.7',
     color: '#0d0d0d',
    margin: 0
  }}>
    Though it's the age of AI, companies prefer certified persons. Transform your programming career through a globally recognized Java certification program. Use <strong style={{ color: 'rgb(21, 20, 20)' }}>Javalearn.clustermicro.com</strong> to practice with <strong style={{ color: 'rgb(11, 11, 11)' }}>1,624 timed practice questions</strong>.
  </p>
</div>

{/* TWO COLUMN SECTION: Exam Types + Study Modes | Get Started */}
<div className="two-column-grid" style={{
  display: 'grid',
  gridTemplateColumns: '1.2fr 0.8fr',
  gap: '18px',
  marginBottom: '18px',
  alignItems: 'stretch'
}}>
  
  {/* LEFT: Exam Types + Study Modes */}
  <div style={{
  display: 'flex',
  flexDirection: 'column',
  height: '100%'   // ✅ critical
}}>
    {/* Exam Types */}
    <div style={{
      //backgroundColor: '#fbedd8ff',
      backgroundColor: '#ffffff',
      padding: '32px',
      borderRadius: '12px',
      border: '1px solid rgba(0,0,0,0.1)',
      boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
      marginBottom: '18px'
    }}>
      <h3 style={{
        fontSize: '22px',
        fontWeight: '700',
        marginBottom: '20px',
        color: '#000000',
      }}>
        Exam Types
      </h3>

      <div style={{ display: 'grid', gap: '16px' }}>
        {[
          {
           // icon: '🎯',
            title: 'Certification Tests - 29 Fixed test sets',
            desc: 'Total 1624 questions. each test has 56 questions • 120 minutes • 29 Fixed test sets',
          },
          {
           // icon: '🎲',
            title: 'Random Practice',
            desc: '56 questions • 120 minutes • Random selection',
          },
          {
           // icon: '🔀',
            title: 'Mixed Practice',
            desc: '50 questions • Dynamic time • All chapters combined',
          },
          // {
          //   icon: '📖',
          //   title: 'Chapter Focus',
          //   desc: 'Up to 48 questions • Single chapter study',
          // },
        ].map((item, idx) => (
          <div
            key={idx}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              padding: '16px',
              backgroundColor: 'rgb(255, 255, 255)',
              borderRadius: '8px',
              borderLeft: '5px solid #575757e5'
              // boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
            }}
          >
            <span style={{ fontSize: '20px', marginRight: '12px' }}>{item.icon}</span>
            <div>
              <div style={{
                fontSize: '15px',
                fontWeight: '600',
                marginBottom: '4px',
                color: '#000000',
              }}>
                {item.title}
              </div>
              <div style={{ fontSize: '14px', color: '#374151' }}>{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* Study Modes - Combined */}
    <div style={{
      //backgroundColor: '#fbedd8ff',

      backgroundColor: '#ffffff',
      padding: '32px',
      borderRadius: '12px',
      border: '1px solid rgba(0,0,0,0.1)',
      boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
      flexGrow: 1,
    }}>
      <h3 style={{
        fontSize: '22px',
        fontWeight: '700',
        marginBottom: '20px',
        color: '#000000',
      }}>
        Study Modes
      </h3>

      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
      }}>
        {/* Practice Mode */}
        <div style={{
          backgroundColor: 'rgba(242, 242, 242, 0.1)',
          padding: '16px',
          borderRadius: '8px',
          border: '1px solid rgba(16, 185, 129, 0.25)',
        }}>
          <div style={{
            fontSize: '14px',
            fontWeight: '600',
            marginBottom: '8px',
            color: '#065f46',
          }}>
            📚 Practice Mode
          </div>
          <ul style={{ margin: 0, padding: 0, listStyle: 'none', color: '#000000', fontSize: '13px' }}>
            <li style={{ marginBottom: '4px' }}>✓ Explanations immediately</li>
            <li style={{ marginBottom: '4px' }}>✓ Learn as you practice</li>
            <li>✓ No time pressure</li>
          </ul>
        </div>

        {/* Exam Mode */}
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          padding: '16px',
          borderRadius: '8px',
          border: '1px solid rgba(239, 68, 68, 0.25)',
        }}>
          <div style={{
            fontSize: '14px',
            fontWeight: '600',
            marginBottom: '8px',
            color: '#7f1d1d',
          }}>
            ⏱️ Exam Mode
          </div>
          <ul style={{ margin: 0, padding: 0, listStyle: 'none', color: '#000000', fontSize: '13px' }}>
            <li style={{ marginBottom: '4px' }}>✓ Real exam conditions</li>
            <li style={{ marginBottom: '4px' }}>✓ No explanations</li>
            <li>✓ Timed experience</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

          {/* RIGHT: Get Started */}
          <div style={{...styles.card, padding: '45px', backgroundColor: '#ffffff'}}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: 'bold',
              margin: '0 0 8px 0',
              textAlign: 'center',
              color: '#111827'
            }}>
              Get Started
            </h2>
            
            <p style={{
              textAlign: 'center',
              color: '#111827',
              fontSize: '14px',
              marginBottom: '22px'
            }}>
              Join thousands of developers preparing for certification
            </p>

            <button
              onClick={() => setCurrentPage('register')}
              style={{...styles.primaryButton, marginBottom: '18px'}}
            >
              Create Account
            </button>
            
            <button
              onClick={() => setCurrentPage('login')}
              style={{...styles.secondaryButton, width: '100%'}}
            >
              Already have an account? Login
            </button>
            
            <div style={{
              marginTop: '16px',
              paddingTop: '24px',
              paddingLeft: '20px',
              borderTop: '1px solid #e5e7eb',
              backgroundColor: '#ffffff',
              borderLeft: '5px solid #ef360c',
            }}>
              <h3 style={{
                fontSize: '15px',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '16px',
                textAlign: 'center'
              }}>
                ✅ What's Included:
              </h3>
              <ul style={{
                fontSize: '14px',
                color: '#111827',
                lineHeight: '2',
                paddingLeft: '20px',
                margin: 0
              }}>
                <li>Full certification practice exams</li>
                {/* <li>Chapter-wise practice tests</li> */}
                <li>Instant score & analytics</li>
                <li>Detailed answer explanations</li>
                <li>6 months unlimited access</li>
                <li>🔒 Certificate access and history are available with a full subscription.</li>
              </ul>
            </div>
            
            <div style={{
              marginTop: '24px',
              padding: '16px',
              backgroundColor: '#ffffff',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{fontSize: '24px', fontWeight: 'bold', color: '#111827', marginBottom: '4px'}}>
                From ₹1,400 / $16
              </div>
              <div style={{
                fontSize: '13px',
                color: '#111827'
              }}>
                One-time payment • 6 months unlimited access
              </div>
              {/* 🎁 Free trial note */}
              <div style={{
                marginTop: '12px',
                padding: '12px',
                backgroundColor: '#ffffff',
                borderRadius: '8px',
                border: '1px solid #bbf7d0'
              }}>
                <span style={{ marginRight: '8px' }}>🎁</span>
                <span style={{ fontSize: '14px', color: '#166534' }}>
                  <strong>For Free Trial (30 Questions)</strong>, please create an account first!
                </span>
              </div>
            </div>
          </div>
        </div>
{/* ADD THIS NEW SECTION - Right after Exam Types, before Get Started */}

{/* Chapter Coverage Section */}
{/* Chapter Coverage Section */}
<div style={{
  backgroundColor: '#ffffff',
  padding: '32px',
  borderRadius: '12px',
  border: '1px solid rgba(0,0,0,0.1)',
  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
  marginBottom: '18px'
}}>
  <h3 style={{
    fontSize: '22px',
    fontWeight: '700',
    marginBottom: '20px',
    color: '#000000',
    textAlign: 'center'
  }}>
    Complete Chapter Coverage
  </h3>

  <div style={{
    display: 'grid',
    gridTemplateColumns: window.innerWidth > 768 ? 'repeat(2, 1fr)' : '1fr',
    gap: '12px'
  }}>
    {[
      { chapter: 'Chapter 1: Java Basics', count: 82, percent: 5.0 },
  { chapter: 'Chapter 2: Data Types, Operators & Flow Control', count: 183, percent: 11.3 },
  { chapter: 'Chapter 3: Methods, Overloading & Encapsulation', count: 208, percent: 12.8 },
  { chapter: 'Chapter 4: Arrays, Constructors & Static', count: 180, percent: 11.1 },
  { chapter: 'Chapter 5: Inheritance, Interfaces & ArrayList', count: 153, percent: 9.4 },
  { chapter: 'Chapter 6: Constructors, this/super & Exceptions', count: 138, percent: 8.5 },
  { chapter: 'Chapter 7: Abstract Classes, Interfaces & Arrays', count: 110, percent: 6.8 },
  { chapter: 'Chapter 8: Polymorphism & Core APIs', count: 193, percent: 11.9 },
  { chapter: 'Chapter 9: Date-Time API & Collections', count: 75, percent: 4.6 },
{ chapter: 'Chapter 10: Mock Exam 1 (+ Lambda Basics)', count: 145, percent: 8.9 },
{ chapter: 'Chapter 11: Mock Exam 2 (+ Bonus Streams Preview)', count: 151, percent: 9.3 },
{ chapter: 'Chapter 12: Bonus — Threading Preview (OCP)', count: 6, percent: 0.4 }
    ].map((item, idx) => (
      <div
        key={idx}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 16px',
          backgroundColor: '#f9fafb',
          borderRadius: '8px',
          border: '1px solid #e5e7eb'
        }}
      >
        <div style={{
          fontSize: '14px',
          color: '#111827',
          fontWeight: '500',
          flex: 1
        }}>
          {item.chapter}
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <span style={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#16a34a'
          }}>
            {item.count}
          </span>
          <span style={{
            fontSize: '12px',
            color: '#6b7280',
            minWidth: '45px',
            textAlign: 'right'
          }}>
            ({item.percent}%)
          </span>
        </div>
      </div>
    ))}
  </div>

  <div style={{
    marginTop: '20px',
    paddingTop: '16px',
    borderTop: '1px solid #e5e7eb',
    textAlign: 'center'
  }}>
    <div style={{
      fontSize: '16px',
      fontWeight: '600',
      color: '#111827',
      marginBottom: '8px'
    }}>
      Total: 1,624 Questions
    </div>
    <div style={{
      fontSize: '13px',
      color: '#6b7280'
    }}>
      ✓ Comprehensive coverage of all OCA Java SE 8 exam topics
    </div>
  </div>
</div>
        {/* FULL WIDTH SECTIONS */}
        <HeroSection />

      </div>
    </div>
  );
}

  // Registration Page
  // if (currentPage === 'register') {
  //   return (
  //     <div style={styles.container}>
  //       <div style={{maxWidth: '500px', margin: '0 auto', padding: '40px 20px'}}>
  //         <div style={{...styles.card, padding: '40px', backgroundColor: '#ffffff'}}>
  //           <h2 style={{fontSize: '28px', fontWeight: 'bold', margin: '0 0 32px 0', textAlign: 'center'}}>
  //             Create Your Account
  //           </h2>
  if (currentPage === 'register') {
  return (
    <div style={styles.container}>
      <div style={{maxWidth: '500px', margin: '0 auto', padding: '40px 20px'}}>
        {/* Header with Logo - Back to Home */}
        <div style={{
          textAlign: 'center',
          marginBottom: '24px',
          cursor: 'pointer'
        }}
        onClick={() => setCurrentPage('landing')}>
          <div style={{
            fontSize: '32px',
            fontWeight: '700',
            color: '#0f1010',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            marginBottom: '8px'
          }}>
            <span>☕</span>
            <span>JavaLearn</span>
          </div>
          <p style={{
            fontSize: '16px',
            color: '#33da36',
             fontWeight: '700',
            margin: 0
          }}>
            ← Back to Home
          </p>
        </div>

        <div style={{...styles.card, padding: '40px', backgroundColor: '#ffffff'}}>
          <h2 style={{fontSize: '28px', fontWeight: 'bold', margin: '0 0 32px 0', textAlign: 'center'}}>
            Create Your Account
          </h2>

            {error && (
              <div style={{
                backgroundColor: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '24px',
                color: '#dc2626'
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleRegister}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Full Name</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  style={styles.input}
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Email Address</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  style={styles.input}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Password</label>
                <div style={{position: 'relative'}}>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                    style={styles.input}
                    placeholder="Create a strong password (8-128 characters)"
                    minLength={8}
                    maxLength={128}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '12px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#6b7280'
                    }}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
                
                <PasswordStrengthIndicator 
                  password={formData.password} 
                  showRequirements={formData.password.length > 0}
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                style={{
                  ...styles.primaryButton,
                  opacity: isLoading ? 0.7 : 1,
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  marginBottom: '16px'
                }}
              >
                {isLoading ? 'Creating Account...' : 'Create Account'}
              </button>

              <button
                type="button"
                onClick={() => setCurrentPage('login')}
                style={{...styles.secondaryButton, width: '100%'}}
              >
                Already have an account? Login
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  // Login Page
  // if (currentPage === 'login') {
  //   return (
  //     <div style={styles.container}>
  //       <div style={{maxWidth: '500px', margin: '0 auto', padding: '40px 20px'}}>
  //         <div style={{...styles.card, padding: '40px', backgroundColor: '#ffffff'}}>
  //           <h2 style={{fontSize: '28px', fontWeight: 'bold', margin: '0 0 32px 0', textAlign: 'center'}}>
  //             Welcome Back
  //           </h2>
  if (currentPage === 'login') {
  return (
    <div style={styles.container}>
      <div style={{maxWidth: '500px', margin: '0 auto', padding: '40px 20px'}}>
        {/* Header with Logo - Back to Home */}
        <div style={{
          textAlign: 'center',
          marginBottom: '24px',
          cursor: 'pointer'
        }}
        onClick={() => setCurrentPage('landing')}>
          <div style={{
            fontSize: '32px',
            fontWeight: '700',
            color: '#0f1010',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            marginBottom: '8px'
          }}>
            <span>☕</span>
            <span>JavaLearn</span>
          </div>
          <p style={{
            fontSize: '16px',
            fontWeight: '700',
            color: '#59be30',
            margin: 0
          }}>
            ← Back to Home
          </p>
        </div>

        <div style={{...styles.card, padding: '40px', backgroundColor: '#ffffff'}}>
          <h2 style={{fontSize: '28px', fontWeight: 'bold', margin: '0 0 32px 0', textAlign: 'center'}}>
            Welcome Back
          </h2>

            {error && (
              <div style={{
                backgroundColor: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '24px',
                color: '#dc2626'
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleLogin}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Email Address</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  style={styles.input}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Password</label>
                <div style={{position: 'relative'}}>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                    style={styles.input}
                    placeholder="Enter your password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '12px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#6b7280'
                    }}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>
              
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                <button
                  type="button"
                  onClick={handleForgotPasswordClick}
                  style={{
                    fontSize: '14px',
                    color: '#667eea',
                    backgroundColor: 'transparent',
                    border: 'none',
                    fontWeight: '500',
                    cursor: 'pointer',
                    padding: '4px 0',
                    transition: 'color 0.3s'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#5568d3'}
                  onMouseOut={(e) => e.target.style.color = '#667eea'}
                >
                  Forgot Password?
                </button>
              </div>
              
              <button
                type="submit"
                disabled={isLoading}
                style={{
                  ...styles.primaryButton,
                  opacity: isLoading ? 0.7 : 1,
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  marginBottom: '16px'
                }}
              >
                {isLoading ? 'Signing In...' : 'Sign In'}
              </button>

              <button
                type="button"
                onClick={() => setCurrentPage('register')}
                style={{...styles.secondaryButton, width: '100%'}}
              >
                Don't have an account? Register
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }



// UPDATED PAYMENT PAGE - Side-by-Side Payment Options
// Replace your "if (currentPage === 'payment')" section in App.js with this:

if (currentPage === 'payment') {
  return (
    <div style={styles.container}>
      <div style={{maxWidth: '1200px', margin: '0 auto', padding: '40px 20px'}}>
        
        {/* Header */}
<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px'}}>
  <div style={{display: 'flex', alignItems: 'center', color: '#111827'}}>  {/* ✅ Black color */}
    <User style={{marginRight: '8px'}} size={24} />
    <span style={{fontSize: '18px', fontWeight: '600'}}>{user?.name}</span>
  </div>
  <button
    onClick={handleLogout}
    style={{...styles.secondaryButton, backgroundColor: 'rgba(255,255,255,0.9)', color: '#667eea'}}
  >
    <LogOut style={{marginRight: '8px'}} size={16} />
    Logout
  </button>
</div>

       {/* Page Title */}
<div style={{textAlign: 'center', marginBottom: '40px'}}>
  <h1 style={{
    fontSize: '36px',
    fontWeight: 'bold',
    color: '#111827',  // ✅ Black color
    marginBottom: '12px'
  }}>
    Choose Your Plan
  </h1>
  <p style={{
    fontSize: '18px',
    color: '#374151'  // ✅ Dark gray/black
  }}>
    Start with a free trial or unlock full access
  </p>
</div>

        {/* Payment Options Grid - 3 Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth > 968 ? 'repeat(3, 1fr)' : '1fr',
          gap: '24px',
          marginBottom: '40px'
        }}>
          
         {/* FREE TRIAL CARD */}
<div style={{...styles.card, padding: '40px', position: 'relative', overflow: 'hidden'}}>
  {/* Badge */}
  <div style={{
    position: 'absolute',
    top: '20px',
    right: '-30px',
    backgroundColor: '#10b981',
    color: 'white',
    padding: '6px 40px',
    transform: 'rotate(45deg)',
    fontSize: '12px',
    fontWeight: 'bold',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
  }}>
    FREE
  </div>

  {/* Icon & Title */}
  <div style={{textAlign: 'center', marginBottom: '32px'}}>
    <div style={{
      width: '80px',
      height: '80px',
      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      borderRadius: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 24px auto'
    }}>
      <Gift color="white" size={40} />
    </div>
    
    <h2 style={{fontSize: '24px', fontWeight: 'bold', margin: '0 0 8px 0'}}>
      Free Trial
    </h2>
    
    <div style={{
      fontSize: '48px',
      fontWeight: 'bold',
      color: '#10b981',
      margin: '16px 0'
    }}>
      30
    </div>
    
    <p style={{color: '#64748b', margin: 0, fontSize: '16px'}}>
      Practice Questions
    </p>
  </div>

  {/* Features */}
  <div style={{
    backgroundColor: '#f0fdf4',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '24px',
    minHeight: '180px'
  }}>
    <h3 style={{
      fontSize: '14px',
      fontWeight: '600',
      color: '#166534',
      marginBottom: '12px'
    }}>
      ✅ What's Included:
    </h3>
    <ul style={{
      fontSize: '14px',
      color: '#166534',
      lineHeight: '2',
      paddingLeft: '20px',
      margin: 0
    }}>
      <li>30 practice questions</li>
      <li>Instant scoring</li>
      <li>Answer explanations</li>
      <li>No credit card needed</li>
    </ul>
  </div>

  {/* Error Message */}
  {trialError && (
    <div style={{
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca',
      borderRadius: '12px',
      padding: '12px',
      marginBottom: '16px',
      fontSize: '14px',
      color: '#dc2626'
    }}>
      {trialError}
    </div>
  )}

  {/* Button */}
  <button
    onClick={handleActivateFreeTrial}
    disabled={isLoading}
    style={{
      width: '100%',
      padding: '16px',
      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '12px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: isLoading ? 'not-allowed' : 'pointer',
      opacity: isLoading ? 0.7 : 1,
      boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
      transition: 'all 0.3s ease'
    }}
  >
    {isLoading ? 'Activating...' : '🎁 Start Free Trial'}
  </button>

  <p style={{
    textAlign: 'center',
    fontSize: '12px',
    color: '#64748b',
    marginTop: '12px'
  }}>
    No payment required
  </p>
</div>

         {/* RAZORPAY CARD */}
<div style={{...styles.card, padding: '40px', position: 'relative', overflow: 'hidden'}}>
  {/* Badge */}
  <div style={{
    position: 'absolute',
    top: '20px',
    right: '-30px',
    backgroundColor: '#ffffff',
color: '#111827',
border: '1px solid #e5e7eb',

    padding: '6px 40px',
    transform: 'rotate(45deg)',
    fontSize: '12px',
    fontWeight: 'bold'
  }}>
    INDIA
  </div>

  {/* Icon & Title */}
  <div style={{textAlign: 'center', marginBottom: '32px'}}>
    <div style={{
      width: '80px',
      height: '80px',
      //background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
      background: '#f9fafb',
border: '1px solid #e5e7eb',
//color: '#111827',
      borderRadius: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 24px auto'
    }}>
      <IndianRupee color="#111827" size={40} />
    </div>
    
    <h2 style={{fontSize: '24px', fontWeight: 'bold', margin: '0 0 8px 0'}}>
      Full Access (INR)
    </h2>
    
    <div style={{fontSize: '48px', fontWeight: 'bold', color: '#111827', margin: '16px 0'}}>
      ₹1400
    </div>
    
    <p style={{fontSize: '16px', color: '#0d0d0dff'}}>
      One-time • 6 months
    </p>
  </div>

  {/* Features */}
  <div style={{
    //backgroundColor: 'rgba(219, 219, 219, 1)',
    backgroundColor: '#ffffff',
border: '1px solid #e5e7eb',
color: '#374151',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '16px',
    minHeight: '180px'
  }}>
    <ul style={{fontSize: '14px', color: '#070707ff', lineHeight: '2', paddingLeft: '20px', margin: 0}}>
    <li>1,624 questions</li>
      <li>29 certification tests</li>
      <li>Detailed answer explanations</li>
      <li>Wrong answer explanation</li>
      <li>Practice Test attendance and passing certificates</li>
      <li>Analytics & certificates</li>
    </ul>
  </div>

  {/* 🆕 RAZORPAY GATEWAY INFO */}
  <div style={{
    padding: '12px',
    //backgroundColor: '#fef3c7',
    backgroundColor: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //border: '1px solid #fef08a'
  }}>
    <Shield 
      size={16} 
      style={{ 
        marginRight: '8px', 
        color: '#0c0c0cff',
        flexShrink: 0 
      }} 
    />
    <p style={{
      margin: 0,
      fontSize: '13px',
      color: '#070707ff',
      fontWeight: '600',
      lineHeight: '1.4'
    }}>
      Payment via Razorpay
    </p>
  </div>

  <p style={{
    textAlign: 'center',
    fontSize: '11px',
    color: '#0b0b0bff',
    marginBottom: '12px'
  }}>
    UPI • Cards • Net Banking • Wallets
  </p>

  {/* Error */}
  {paymentError && (
    <div style={{
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca',
      borderRadius: '12px',
      padding: '12px',
      marginBottom: '16px',
      fontSize: '14px',
      color: '#dc2626'
    }}>
      {paymentError}
    </div>
  )}

  {/* Button */}
  <button
    onClick={async () => {
      setIsLoading(true);
      setPaymentError(null);
      try {
        const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/create-subscription`, {
  method: 'POST',
  body: JSON.stringify({ 
    currency: 'INR', 
    amount: 1400,//change to 1400
    environment: process.env.NODE_ENV === 'production' ? 'live' : 'test' // ✅ NEW
  })
});
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        if (data.orderId) {
          initiateRazorpayCheckout(data);
        }
      } catch (error) {
  if (error.message === 'SESSION_INVALID') return;
  setPaymentError(error.message);
}
 finally {
        setIsLoading(false);
      }
    }}
    disabled={isLoading}
    style={{
      width: '100%',
      padding: '16px',
      //background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
      //color: 'white',
      background: '#e5e7eb',
color: '#111827',
border: '1px solid #d1d5db',

      border: 'none',
      borderRadius: '12px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: isLoading ? 'not-allowed' : 'pointer',
      opacity: isLoading ? 0.7 : 1
    }}
  >
    {isLoading ? 'Processing...' : 'Pay ₹1400'}
  </button>
</div>

          {/* PAYPAL CARD */}
         {/* PAYPAL CARD */}
<div style={{...styles.card, padding: '40px', position: 'relative', overflow: 'hidden'}}>
  {/* Badge */}
  <div style={{
    position: 'absolute',
    top: '20px',
    right: '-30px',
    backgroundColor: '#111827',
    color: 'white',
    padding: '6px 40px',
    transform: 'rotate(45deg)',
    fontSize: '12px',
    fontWeight: 'bold'
  }}>
    GLOBAL
  </div>

  {/* Icon & Title */}
  <div style={{textAlign: 'center', marginBottom: '32px'}}>
    <div style={{
      width: '80px',
      height: '80px',
      //background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      background: '#f3f4f6',
border: '1px solid #e5e7eb',

      borderRadius: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 24px auto'
    }}>
      <DollarSign color="#111827" size={40} />
    </div>
    
    <h2 style={{fontSize: '24px', fontWeight: 'bold', margin: '0 0 8px 0'}}>
      Full Access (USD)
    </h2>
    
    <div style={{fontSize: '48px', fontWeight: 'bold', color: '#111827', margin: '16px 0'}}>
      $16
    </div>
    
    <p style={{fontSize: '16px', color: '#010101ff'}}>
      One-time • 6 months
    </p>
  </div>

  {/* Features */}
  <div style={{
    backgroundColor: '#f8f9ff',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '16px',
    minHeight: '180px'
  }}>
    <ul style={{fontSize: '14px', color: '#111827', lineHeight: '2', paddingLeft: '20px', margin: 0}}>
      <li>1,624 questions</li>
      <li>29 certification tests</li>
      <li>Detailed answer explanations</li>
      <li>Wrong answer explanation</li>
      <li>Practice Test attendance and passing certificates</li>
      <li>Analytics & certificates</li>
    </ul>
  </div>

  {/* 🆕 PAYPAL GATEWAY INFO */}
  <div style={{
    padding: '12px',
    backgroundColor: '#f3f4f6',
    borderRadius: '8px',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #e5e7eb'
  }}>
    <Shield 
      size={16} 
      style={{ 
        marginRight: '8px', 
        color: '#374151',
        flexShrink: 0 
      }} 
    />
    <p style={{
      margin: 0,
      fontSize: '13px',
      color: '#090909ff',
      fontWeight: '600',
      lineHeight: '1.4'
    }}>
      Payment via PayPal
    </p>
  </div>

  <p style={{
    textAlign: 'center',
    fontSize: '11px',
    color: '#6b7280',
    marginBottom: '12px'
  }}>
    Credit Cards • Debit Cards • PayPal Balance
  </p>

  {/* Error */}
  {paymentError && (
    <div style={{
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca',
      borderRadius: '12px',
      padding: '12px',
      marginBottom: '16px',
      fontSize: '14px',
      color: '#dc2626'
    }}>
      {paymentError}
    </div>
  )}

  {/* Button */}
  <button
    onClick={async () => {
      setIsLoading(true);
      setPaymentError(null);
      try {
      const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/create-paypal-order`, {
  method: 'POST',
  body: JSON.stringify({ 
    currency: 'USD', 
    amount: 16,
    environment: process.env.NODE_ENV === 'production' ? 'live' : 'sandbox' // ✅ NEW
  })
});
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        if (data.approvalUrl) {
          window.location.href = data.approvalUrl;
        }
      } catch (error) {
  if (error.message === 'SESSION_INVALID') return;
  setPaymentError(error.message);
} finally {
  setIsLoading(false);
}
    }}
    disabled={isLoading}
    style={{
      width: '100%',
      padding: '16px',
      //background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      background: '#e5e7eb',
      color: '#111827',
      border: '1px solid #d1d5db',
      borderRadius: '12px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: isLoading ? 'not-allowed' : 'pointer',
      opacity: isLoading ? 0.7 : 1
    }}
  >
    {isLoading ? 'Processing...' : 'Pay $16'}
  </button>
</div>

        </div>

      </div>
    </div>
  );
}



  // Dashboard Page
 // Dashboard Page
if (currentPage === 'dashboard') {
  return (
    <div style={styles.container}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px'
      }}>
        {/* Header Section */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '24px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
            <User style={{ marginRight: '8px' }} size={32} />
            <span style={{ fontSize: '18px', fontWeight: '600' }}>{user?.name}</span>
          </div>
          {/* Header Right Section */}
{/* Header Right Section */}
<div style={{ display: 'flex', gap: '12px' }}>
  {/* View Certificates */}
  <button
    onClick={() => {
      if (user?.subscriptionType !== 'trial') {
        setCurrentPage('certificates');
      }
    }}
    disabled={user?.subscriptionType === 'trial'}
    style={{
      ...styles.secondaryButton,
      backgroundColor: 'rgba(255,255,255,0.9)',
      color: user?.subscriptionType === 'trial' ? '#94a3b8' : '#667eea',
      border: `2px solid ${user?.subscriptionType === 'trial' ? '#cbd5e1' : '#667eea'}`,
      cursor: user?.subscriptionType === 'trial' ? 'not-allowed' : 'pointer',
      opacity: user?.subscriptionType === 'trial' ? 0.6 : 1
    }}
    title={
      user?.subscriptionType === 'trial'
        ? 'Available only with full subscription'
        : 'View your earned certificates'
    }
  >
    <Trophy style={{ marginRight: '8px' }} size={16} />
    View Certificates
  </button>

  {/* Logout */}
  {/* <button
    onClick={handleLogout}
    style={{
      ...styles.secondaryButton,
      backgroundColor: 'rgba(255,255,255,0.9)',
      color: '#667eea'
    }}
  >
    <LogOut style={{ marginRight: '8px' }} size={16} />
    Logout
  </button> */}
</div>


        </div>

        {/* Chapter Selector (main content) */}
        <ChapterExamSelector 
          onStartExam={handleStartExam}
          user={user}
          onLogout={handleLogout}
        />
      </div>
    </div>
  );
}


  // Certificates Page
if (currentPage === 'certificates') {
  return (
    <div style={styles.container}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '24px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
            <User style={{ marginRight: '8px' }} size={32} />
            <span style={{ fontSize: '18px', fontWeight: '600' }}>{user?.name}</span>
          </div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={() => setCurrentPage('dashboard')}
              style={{...styles.secondaryButton, backgroundColor: 'rgba(255,255,255,0.9)', color: '#667eea'}}
            >
              Back to Dashboard
            </button>
            <button
              onClick={handleLogout}
              style={{...styles.secondaryButton, backgroundColor: 'rgba(255,255,255,0.9)', color: '#667eea'}}
            >
              <LogOut style={{ marginRight: '8px' }} size={16} />
              Logout
            </button>
          </div>
        </div>

        <CertificateGenerator 
  user={user} 
  examHistory={examHistory}
  apiEndpoint={API_ENDPOINT}
  authToken={authToken}
/>

      </div>
    </div>
  );
}

  // Exam Page
  if (currentPage === 'exam' && questions.length > 0 && !examSubmitted) {
    return (
      <div style={styles.container}>
        <ExamInterface
          questions={questions}
          onSubmitExam={handleSubmitExam}
          timeRemaining={timeRemaining}
          setTimeRemaining={setTimeRemaining}
          user={user}
          examConfig={examConfig}
          onLogout={handleLogout}
        />
      </div>
    );
  }

  // Review Mistakes Page
  if (currentPage === 'review' && lastAttempt) {
    console.log("📘 Rendering ExamReview page for last attempt");
    return (
      <div style={{ backgroundColor: '#f3f4f6', minHeight: '100vh', padding: '20px' }}>
        <ExamReview
          attempt={lastAttempt}
          onBack={() => {
            console.log("⬅️ Returning to results page");
            setCurrentPage('results');
          }}
        />
      </div>
    );
  }

  // Results Page
  if (currentPage === 'results' || examSubmitted) {
    const totalQuestions = questions.length;
    const percentage = totalQuestions > 0 ? ((score / totalQuestions) * 100).toFixed(1) : 0;
    const passed = parseFloat(percentage) >= 65;
    const examTypeLabel = EXAM_TYPE_LABELS[examConfig?.type] || "Unknown Type";

    return (
      <div style={styles.container}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
              <User style={{ marginRight: '8px' }} size={32} />
              <span style={{ fontSize: '18px', fontWeight: '600' }}>{user?.name}</span>
            </div>
            <button
              onClick={handleLogout}
              style={{ ...styles.secondaryButton, backgroundColor: 'rgba(255,255,255,0.9)', color: '#667eea' }}
            >
              <LogOut style={{ marginRight: '8px' }} size={16} />
              Logout
            </button>
          </div>

          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ ...styles.card, padding: '40px' }}>
              <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                {passed ? (
                  <>
                    <Trophy style={{ color: '#f59e0b', margin: '0 auto 16px auto' }} size={96} />
                    <h1
                      style={{
                        fontSize: '36px',
                        fontWeight: 'bold',
                        margin: '0 0 16px 0',
                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                      }}
                    >
                      Congratulations!
                    </h1>
                    <p style={{ fontSize: '20px', color: '#64748b' }}>
                      You passed the {examTypeLabel} Exam!
                    </p>
                  </>
                ) : (
                  <>
                    <TrendingUp style={{ color: '#f59e0b', margin: '0 auto 16px auto' }} size={96} />
                    <h1 style={{ fontSize: '36px', fontWeight: 'bold', margin: '0 0 16px 0' }}>Exam Complete</h1>
                    <p style={{ fontSize: '20px', color: '#64748b' }}>Keep practicing to improve your score</p>
                  </>
                )}
              </div>

              <div
                style={{
                  padding: '32px',
                  backgroundColor: '#f8fafc',
                  borderRadius: '16px',
                  marginBottom: '32px',
                }}
              >
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '32px',
                    textAlign: 'center',
                  }}
                >
                  <div>
                    <p style={{ color: '#64748b', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                      Your Score
                    </p>
                    <p style={{ fontSize: '48px', fontWeight: 'bold', color: '#667eea', margin: 0 }}>
                      {score}/{totalQuestions}
                    </p>
                  </div>
                  <div>
                    <p style={{ color: '#64748b', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                      Percentage
                    </p>
                    <p style={{ fontSize: '48px', fontWeight: 'bold', color: '#8b5cf6', margin: 0 }}>{percentage}%</p>
                  </div>
                </div>

                <div
                  style={{
                    marginTop: '20px',
                    paddingTop: '20px',
                    borderTop: '1px solid #e2e8f0',
                    textAlign: 'center',
                  }}
                >
                  <p style={{ color: '#64748b', fontSize: '14px', margin: '0' }}>
                    Exam Type: <strong>{examTypeLabel}</strong>
                  </p>
                  {examConfig?.chapter && (
                    <p style={{ color: '#64748b', fontSize: '12px', margin: '4px 0 0 0' }}>
                      Chapter Focus: {examConfig.chapter}
                    </p>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
                <button
                  onClick={() => {
                    setExamSubmitted(false);
                    setScore(0);
                    setError(null);
                    setCurrentPage('dashboard');
                  }}
                  style={{ ...styles.primaryButton, flex: 1, minWidth: '200px' }}
                >
                  Take Another Exam
                </button>

                <button
                  onClick={() => setCurrentPage('dashboard')}
                  style={{ ...styles.secondaryButton, padding: '16px 32px' }}
                >
                  Back to Dashboard
                </button>

                {lastAttempt && (
                  <button
                    onClick={() => setCurrentPage('review')}
                    style={{
                      ...styles.secondaryButton,
                      backgroundColor: '#fef3c7',
                      color: '#92400e',
                      border: '1px solid #fcd34d',
                    }}
                  >
                    Review Mistakes
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showForgotPassword || currentPage === 'forgot-password') {
    return (
      <ForgotPassword 
        onBack={handleBackToLogin}
        apiEndpoint={API_ENDPOINT}
      />
    );
  }

  if (showResetPassword || currentPage === 'reset-password') {
    return (
      <ResetPassword 
        apiEndpoint={API_ENDPOINT}
        onSuccess={handleResetPasswordSuccess}
        onBack={handleBackToLogin}
      />
    );
  }

  return null;
}

export default App;